window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
* Cart Template Script
* ------------------------------------------------------------------------------
* A file that contains scripts highly couple code to the Cart template.
*
* @namespace cart
*/

slate.cart = {

	/**
	* Browser cookies are required to use the cart. This function checks if
	* cookies are enabled in the browser.
	*/
	cookiesEnabled: function() {
		var cookieEnabled = navigator.cookieEnabled;

		if (!cookieEnabled){
			document.cookie = 'testcookie';
			cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
		}
		return cookieEnabled;
	}
};

var selectors = {
	totalPrice : '[data-cart-total-price]',
	updateLineNumber : '[data-cart-update-line-number]',
	acceptText : '[data-accept-text]'
}

$('[data-checkout-button]').click(function(e){
	// console.log($('[data-accept]').is(':checked'));
  if($('[data-accept]').is(':checked') == false){
    e.preventDefault();
	$(selectors.acceptText).css('opacity', 1);
  }
});

$(function(){
	if (window.Shopify && Shopify.StorefrontExpressButtons) {
	  Shopify.StorefrontExpressButtons.initialize();
	}
})

$('[data-accept]').change(function(){
	if($(this).is(':checked')){
		$('[data-checkout-button]').removeClass('button--disabled');
			$(selectors.acceptText).css('opacity', 0);
	}else{
		$('[data-checkout-button]').addClass('button--disabled');
		$(selectors.acceptText).css('opacity', 1);
	}
});
$('[data-cart-remove-index]').click(function(){
	var index = $(this).attr('data-cart-remove-index');
	CartJS.removeItem(index, 0);
	setTimeout(function(){window.location.reload()}, 500);
})
// $('[data-checkout-button]').click(function(e){
//   console.log($('[data-accept]')[0].checked);
//   if(!$('[data-accept]').prop('checked')){
//     e.preventDefault();
//     $(selectors.acceptText).show();
//   }
// })
// $('[data-accept]').change(function(){
//   var self = $(this);
//   if(this.checked){
//     $('[data-checkout-button]').each(function(){
//         self.prop('checked', false);
//         $(this).removeClass('button--disabled');
//         $(selectors.acceptText).hide();
//     });
//   }else{
//     $('[data-checkout-button]').each(function(){
//         self.prop('checked', true);
//         $(selectors.acceptText).show();
//         $(this).addClass('button--disabled');
//     });
//   }
// });

$("body").on('change', selectors.updateLineNumber, function(){
	var self = $(this);
	var line_number = $(this).attr('data-cart-update-line-number');
	var quantity = $(this).val();
	// console.log('Change cart quantity ', quantity);
	// console.log('Change cart line_number ', line_number);

	var cartReturn = CartJS.updateItem(line_number, quantity, properties = {}, options = {
		"success" : function(responseJSON, textStatus, jqXHR){
			// console.log('Success , data :', responseJSON);
			var totalPrice = cartReturn.responseJSON.total_price;
			var itemPrice = cartReturn.responseJSON.items[line_number - 1].line_price;
			// console.log(totalPrice);
			// console.log(itemPrice);
			self.parents('[data-cart-item]').find('[data-item-price]').html(Number(itemPrice / 100).toFixed(2) + '€');
			$(selectors.totalPrice).html(Number(totalPrice / 100).toFixed(2) + '€')
		}
	});
})

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];
    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    if (src != undefined)
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      //console.log('Select change');
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }
      //console.log('Variant image change');
      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      // if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
      //   return;
      // }
      //console.log('Update price');

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ General ================*/
(function () {
	"use strict";

	var doT = {
		name: "doT",
		version: "1.1.1",
		templateSettings: {
			evaluate:    /\{\$([\s\S]+?(\}?)+)\}\}/g,
			interpolate: /\{\$=([\s\S]+?)\}\}/g,
			encode:      /\{\$!([\s\S]+?)\}\}/g,
			use:         /\{\$#([\s\S]+?)\}\}/g,
			useParams:   /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
			define:      /\{\$##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
			defineParams:/^\s*([\w$]+):([\s\S]+)/,
			conditional: /\{\$\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
			iterate:     /\{\$~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,
			varname:	"zerance",
			strip:		true,
			append:		true,
			selfcontained: false,
			doNotSkipEncoded: false
		},
		template: undefined, //fn, compile template
		compile:  undefined, //fn, for express
		log: true
	}, _globals;

	doT.encodeHTMLSource = function(doNotSkipEncoded) {
		var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
			matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
		return function(code) {
			return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
		};
	};

	_globals = (function(){ return this || (0,eval)("this"); }());

	/* istanbul ignore else */
	if (typeof module !== "undefined" && module.exports) {
		module.exports = doT;
	} else if (typeof define === "function" && define.amd) {
		define(function(){return doT;});
	} else {
		_globals.doT = doT;
	}

	var startend = {
		append: { start: "'+(",      end: ")+'",      startencode: "'+encodeHTML(" },
		split:  { start: "';out+=(", end: ");out+='", startencode: "';out+=encodeHTML(" }
	}, skip = /$^/;

	function resolveDefs(c, block, def) {
		return ((typeof block === "string") ? block : block.toString())
		.replace(c.define || skip, function(m, code, assign, value) {
			if (code.indexOf("def.") === 0) {
				code = code.substring(4);
			}
			if (!(code in def)) {
				if (assign === ":") {
					if (c.defineParams) value.replace(c.defineParams, function(m, param, v) {
						def[code] = {arg: param, text: v};
					});
					if (!(code in def)) def[code]= value;
				} else {
					new Function("def", "def['"+code+"']=" + value)(def);
				}
			}
			return "";
		})
		.replace(c.use || skip, function(m, code) {
			if (c.useParams) code = code.replace(c.useParams, function(m, s, d, param) {
				if (def[d] && def[d].arg && param) {
					var rw = (d+":"+param).replace(/'|\\/g, "_");
					def.__exp = def.__exp || {};
					def.__exp[rw] = def[d].text.replace(new RegExp("(^|[^\\w$])" + def[d].arg + "([^\\w$])", "g"), "$1" + param + "$2");
					return s + "def.__exp['"+rw+"']";
				}
			});
			var v = new Function("def", "return " + code)(def);
			return v ? resolveDefs(c, v, def) : v;
		});
	}

	function unescape(code) {
		return code.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
	}

	doT.template = function(tmpl, c, def) {
		c = c || doT.templateSettings;
		var cse = c.append ? startend.append : startend.split, needhtmlencode, sid = 0, indv,
			str  = (c.use || c.define) ? resolveDefs(c, tmpl, def || {}) : tmpl;

		str = ("var out='" + (c.strip ? str.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g," ")
					.replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g,""): str)
			.replace(/'|\\/g, "\\$&")
			.replace(c.interpolate || skip, function(m, code) {
				return cse.start + unescape(code) + cse.end;
			})
			.replace(c.encode || skip, function(m, code) {
				needhtmlencode = true;
				return cse.startencode + unescape(code) + cse.end;
			})
			.replace(c.conditional || skip, function(m, elsecase, code) {
				return elsecase ?
					(code ? "';}else if(" + unescape(code) + "){out+='" : "';}else{out+='") :
					(code ? "';if(" + unescape(code) + "){out+='" : "';}out+='");
			})
			.replace(c.iterate || skip, function(m, iterate, vname, iname) {
				if (!iterate) return "';} } out+='";
				sid+=1; indv=iname || "i"+sid; iterate=unescape(iterate);
				return "';var arr"+sid+"="+iterate+";if(arr"+sid+"){var "+vname+","+indv+"=-1,l"+sid+"=arr"+sid+".length-1;while("+indv+"<l"+sid+"){"
					+vname+"=arr"+sid+"["+indv+"+=1];out+='";
			})
			.replace(c.evaluate || skip, function(m, code) {
				return "';" + unescape(code) + "out+='";
			})
			+ "';return out;")
			.replace(/\n/g, "\\n").replace(/\t/g, '\\t').replace(/\r/g, "\\r")
			.replace(/(\s|;|\}|^|\{)out\+='';/g, '$1').replace(/\+''/g, "");
			//.replace(/(\s|;|\}|^|\{)out\+=''\+/g,'$1out+=');

		if (needhtmlencode) {
			if (!c.selfcontained && _globals && !_globals._encodeHTML) _globals._encodeHTML = doT.encodeHTMLSource(c.doNotSkipEncoded);
			str = "var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : ("
				+ doT.encodeHTMLSource.toString() + "(" + (c.doNotSkipEncoded || '') + "));"
				+ str;
		}
		try {
			return new Function(c.varname, str);
		} catch (e) {
			/* istanbul ignore else */
			if (typeof console !== "undefined") console.log("Could not create a template function: " + str);
			throw e;
		}
	};

	doT.compile = function(tmpl, def) {
		return doT.template(tmpl, null, def);
	};
}());

/*================ Sections ================*/
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {
  var selectors = {
    guideToggle: '[data-toggle-guide]',
    productSlider: '[data-product-slider]',
    productThumbnail: '[data-product-thumbnail]',
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    singleOptionSelector: '[data-single-option-selector]',
    singleOptionTrigger: '[data-single-option-trigger]',
    showPopupSlider : '[data-show-image-popup]',
    showVideoSlider : '[data-show-video-popup]',
    hideImagePopup : '[data-hide-image-popup]',
    popupSlider: '[data-popup-slider]',
    popupThumbnail: '[data-popup-thumbnail]',

    cardOption : '[data-option-value]',
    optionContainer : '[data-option-container]',
    cardOptionTrigger: '[data-card-option-trigger]',

    variantUnavailable : '[data-variant-unavailable]',
    variantText : '[data-variant-text]',
    productQuantity : '[data-product-quantity]'

  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var self = this;

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.imagesObject = product_images;

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
    slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));


    this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));

    var self = this;

    this.initVariantsTrigger();
    this.initImageSlider();
    this.initPopupSlider();
    this.setDeliveryDate();
    this.updateStocksDisplay();
    $(selectors.showPopupSlider).click(this.showPopupSlider.bind(this));
    $(selectors.showVideoSlider).click(this.showVideoSlider.bind(this));
    $(selectors.hideImagePopup).click(this.hidePopupSlider.bind(this));
    $(selectors.productQuantity).change(function(){
      $(selectors.singleOptionSelector).trigger('change');
    });
    $(selectors.singleOptionSelector).trigger('change');
    $('[data-special-color]').each(function(){
      if($(this).children().length <= 0) $(this).prev().hide();
    });
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */

    updateAddToCartState: function(evt) {
      var variant = evt.variant;
      var self = this;

      if (variant) {
        $(selectors.variantUnavailable).hide();
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.variantUnavailable).show();
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCart, this.$container).addClass('button--reverse');
        $(selectors.addToCart, this.$container).addClass('button--disabled');
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.variantUnavailable).hide();
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCart, this.$container).removeClass('button--reverse');
        $(selectors.addToCart, this.$container).removeClass('button--disabled');
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.variantUnavailable).show();
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCart, this.$container).addClass('button--reverse');
        $(selectors.addToCart, this.$container).addClass('button--disabled');
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
      //console.log('Variant : ', variant);
      this.updateStocksDisplay(variant);
    },

    // Gére les affichages concernant les stocks. Impossible si + de 2 options
    updateStocksDisplay : function(variant){
      var self = this;

      if(!variant) return;
      $(selectors.singleOptionTrigger).each(function(){
        if($(this).attr('data-option-value') == variant.option1 || $(this).attr('data-option-value') == variant.option2){
          $(this).addClass('selected');
        }else{
          $(this).removeClass('selected');
        }
      });

      if(self.productSingleObject.options.length == 2){
        $(selectors.optionContainer).each(function(){
          $(this).find(selectors.cardOptionTrigger).each(function(){
            if($(this).hasClass('selected')){
              // Gère l'affichage des stocks
              var selectedOption = $(this).attr('data-option-value');

              // Modifier le nom de la variante couleur
                if($(this).attr('data-option') == 'Color'){
                  var color = selectedOption;
                  if(variant && variant.option1) color = variant.option1;
                  $(selectors.variantText).html(' : ' + color);
                  // if($(this).parent().get(0).hasAttribute('data-special-color')){
        					// 	$(selectors.variantText).hide();
        					// 	$('[data-special-color]').prev().find(selectors.variantText).show();
        					// }else{
        						$(selectors.variantText).show();
        					// 	$('[data-special-color]').prev().find(selectors.variantText).hide();
        					// }
                }

              $(selectors.cardOption).each(function(){
                var option = $(this).attr('data-option-value');
                for(var i = 0; i < self.productSingleObject.variants.length; i++){
                  var variant = self.productSingleObject.variants[i];
                  if((variant.option1 == selectedOption && variant.option2 == option) ||
                    (variant.option2 == selectedOption && variant.option1 == option)){
                    if(variant.available){
                      $(this).removeClass('unavailable');
                    }else{
                      $(this).addClass('unavailable');
                    }
                  }
                }
              });
            }
          })
        });
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      var totalPrice = variant.price * $(selectors.productQuantity).val();
      //console.log('New total Price', totalPrice);
      $(selectors.productPrice, this.$container).each(function(){
        $(this).html(slate.Currency.formatMoney(totalPrice, theme.moneyFormat));
      })


      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
     // console.log('Update product image');
     // console.log(evt);
      var variant = evt.variant;

      this.destroyImageSlider();
      this.destroyPopupSlider();
      this.buildImageSlider(variant);
      this.buildPopupSlider(variant);
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
    },

    destroyImageSlider : function(){
      $(selectors.productSlider).css('opacity', 0);
      $(selectors.productThumbnail).css('opacity', 0);

        if(this.$productSlider.flickity){
          this.$productSlider.flickity('destroy');
        }
        this.$productSlider.html('');
        if(this.$productThumbnail.flickity){
          this.$productThumbnail.flickity('destroy');
        }
        this.$productThumbnail.html('');
    },

    buildImageSlider : function(variant){
      var image, sliderHtml = '', thumbnailHtml = '';
      for(var i = 0; i < this.imagesObject.length; i++){
        image = this.imagesObject[i];
        if((image.alt.indexOf(variant.option1) !== -1 || image.alt.indexOf('multi') !== -1) && (variant.option1 !== 'Juste Le Bleu' || (variant.option1 === 'Juste Le Bleu' && image.alt.indexOf('Juste Le Bleu Gris') == -1)) && (variant.option1 !== 'Juste Le Rayé' || (variant.option1 === 'Juste Le Rayé' && image.alt.indexOf('Juste Le Rayé Sable') == -1)) && (variant.option1 !== 'Juste Le Rayé' || (variant.option1 === 'Juste Le Rayé' && image.alt.indexOf('Juste Le Rayé Bleu') == -1))){
          sliderHtml += '<div class="carousel-cell full-width"><img class="product__slider-image" data-show-image-popup src="' + image.src + '" alt="' + image.alt + '"></div>';
          thumbnailHtml += '<div class="carousel-cell"><div class="thumbnail thumbnail--circled" style="background-image:url('+ image.src + ')"></div></div>';
        }
      }
      // if(product_video_url && product_video_image){
      //   sliderHtml += '<div class="carousel-cell full-width"><img data-show-image-popup class="product__slider-image" src="' + product_video_image + '" alt="{{ image.alt | escape }}"></div>';
      //   thumbnailHtml += '<div class="carousel-cell"><div class="thumbnail thumbnail--circled" style="background-image:url(\'' + product_video_image + '\')"></div></div>';
      // }
      this.$productSlider.html(sliderHtml);
      this.$productThumbnail.html(thumbnailHtml);
      this.initImageSlider();
    },

    initImageSlider : function(){
      var self = this;

        this.$productSlider = $(selectors.productSlider).flickity({
          wrapAround : true, imagesLoaded: true, "pageDots": true , "groupCells": 1, "contain" : true, "cellAlign": "left", "arrowShape" : {"x0":30,"x1":60,"y1":25,"x2":65,"y2":25,"x3":35}
        });

        this.$productSlider.on('ready.flickity', function(){
          self.$productSlider.resize();
          $(selectors.productSlider).css('opacity', 1);
          $(selectors.productThumbnail).css('opacity', 1);
          setTimeout(function(){

          }, 100)
        });

        this.$productThumbnail = $(selectors.productThumbnail).flickity({
          asNavFor : '.product__slider',
          prevNextButtons: false,
          pageDots : false,
          groupCells: true
        });
        $(selectors.showPopupSlider).click(this.showPopupSlider.bind(this));
        $(selectors.hideImagePopup).click(this.hidePopupSlider.bind(this));
    },

    initVariantsTrigger : function(){
      $(selectors.singleOptionTrigger).click(function(){
        $(this).prev().click();
        $(this).parents('.selector-wrapper').find(selectors.singleOptionTrigger).each(function(){
          $(this).removeClass('selected');
        });
        $(this).addClass('selected');
      });
    },
    destroyPopupSlider : function(){
      $(selectors.popupSlider).css('opacity', 0);
      $(selectors.popupThumbnail).css('opacity', 0);

        if(this.$popupSlider.flickity){
          this.$popupSlider.flickity('destroy');
        }
        this.$popupSlider.html('');
        if(this.$popupThumbnail.flickity){
          this.$popupThumbnail.flickity('destroy');
        }
        this.$popupThumbnail.html('');
    },
    hidePopupSlider : function(){
      $('.product__popup-container').removeClass('product__popup-container--activated');
    },
    showPopupSlider : function(){
      //console.log('Show popup slider');
      $('.product__popup-container').addClass('product__popup-container--activated');
    },
    showVideoSlider : function(){
      //console.log('Show popup slider');
      var length =  $('[data-product-thumbnail] .carousel-cell').length;
      this.$popupSlider.flickity('select', length - 1);
      $('.product__popup-container').addClass('product__popup-container--activated');
    },
    buildPopupSlider : function(variant){
      var image, sliderHtml = '', thumbnailHtml = '';
      for(var i = 0; i < this.imagesObject.length; i++){
        image = this.imagesObject[i];
        if((image.alt.indexOf(variant.option1) !== -1 || image.alt.indexOf('multi') !== -1) && (variant.option1 !== 'Juste Le Bleu' || (variant.option1 === 'Juste Le Bleu' && image.alt.indexOf('Juste Le Bleu Gris') == -1)) && (variant.option1 !== 'Juste Le Rayé' || (variant.option1 === 'Juste Le Rayé' && image.alt.indexOf('Juste Le Rayé Sable') == -1))){
          sliderHtml += '<div class="carousel-cell full-width"><img class="product__slider-image" src="' + image.src + '" alt="' + image.alt + '"></div>';
          thumbnailHtml += '<div class="carousel-cell"><div class="thumbnail thumbnail--circled" style="background-image:url('+ image.src + ')"></div></div>';
        }
      }
      // if(product_video_url && product_video_image){
      //   sliderHtml += '<div class="carousel-cell full-width"><video class="product__video" autoplay loop controls><source src="' + product_video_url + '" type="video/mp4"><p>Votre navigateur ne prend pas en charge les vidéos HTML5.</video></div>';
      //   thumbnailHtml += '<div class="carousel-cell"><div class="thumbnail thumbnail--circled" style="background-image:url(\'' + product_video_image + '\')"></div></div>';
      // }
      this.$popupSlider.html(sliderHtml);
      this.$popupThumbnail.html(thumbnailHtml);
      this.initPopupSlider();
    },

    initPopupSlider : function(){
      var self = this;

        this.$popupSlider = $(selectors.popupSlider).flickity({
          sync:'.product__slider', wrapAround : true, imagesLoaded: true, "pageDots": true , "groupCells": 1, "contain" : true, "cellAlign": "left", "arrowShape" : {"x0":30,"x1":60,"y1":25,"x2":65,"y2":25,"x3":35}
        });

        this.$popupSlider.on('ready.flickity', function(){
          self.$popupSlider.resize();
          $(selectors.popupSlider).css('opacity', 1);
          $(selectors.popupThumbnail).css('opacity', 1);
        });

        this.$popupThumbnail = $(selectors.popupThumbnail).flickity({
          asNavFor : '.product__slider--popup',
          prevNextButtons: false,
          pageDots : false,
          groupCells: true
        });
        $('.product__popup').click(function(event){event.stopPropagation();})
    },
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
  },
  setDeliveryDate:function(){
       var date = new Date();
       var isWeekend = date.getDay()%6==0;
       var hours = date.getHours();
       if(isWeekend || hours > 12){
           var nextDay = new Date(date);
               nextDay.setDate(date.getDate() + 1);
           var nextDayString = nextDay.toLocaleString('fr', {  weekday: 'long' });
           var nextDateString = nextDay.toLocaleString('fr', {  weekday: 'long', day : 'numeric', month : 'long' });
           if(nextDayString == 'vendredi' || nextDayString == 'samedi' || nextDayString == 'dimanche'){
               var nextMonday = new Date();
                   nextMonday.setDate(nextMonday.getDate() + (1 + 7 - nextMonday.getDay()) % 7);
               var nextMondayString = nextMonday.toLocaleString('fr', {  weekday: 'long', day : 'numeric', month : 'long' });
               $('[data-delivery-date]').html(nextMondayString);
           }else{
               $('[data-delivery-date]').html(nextDateString);
           }
       }else{
           $('[data-delivery-date]').html('aujourd\'hui');
       }
   }
  });

  return Product;
})();

/**
* Bundle Template Script
* ------------------------------------------------------------------------------
* A file that contains scripts highly couple code to the Product template.
*
* @namespace bundleß
*/

theme.Bundle = (function() {
	var selectors = {
		priceWrapper : '[data-price-wrapper]',
		productJson: '[data-product-json]',
		cardJson : '[data-card-json]',
		card : '[data-card]',
		cardPlus : '[data-card-plus]',
		cardMinus : '[data-card-minus]',
		cardToggle : '[data-card-toggle]',
		productFeaturedImage: '[data-product-featured-image]',

		cardOptionValue : '[data-card-option-value]',
		cardOptionTrigger: '[data-card-option-trigger]',
		optionContainer : '[data-option-container]',
		cardOption : '[data-option]',

		bundlePrice : '[data-bundle-price]',
		productSlider: '[data-product-slider]',
		productThumbnail: '[data-product-thumbnail]',
		variantUnavailable : '[data-variant-unavailable]',
		variantText : '[data-variant-text]',

		productSelect : '[data-product-select]',
		productPrice : '[data-product-price]',
		cardPoint : '[data-card-point]',
		showPopupSlider : '[data-show-image-popup]',
		hideImagePopup : '[data-hide-image-popup]',
		popupSlider: '[data-popup-slider]',
		popupThumbnail: '[data-popup-thumbnail]',

		checkoutAdd : '[data-checkout-addtocart]',
		checkoutDisabled : '[data-checkout-disabled]',
		checkoutButton : '[data-add-to-cart]',
		checkoutInfo : '[data-info]',
		lineItemsWrapper : '[data-line-items-wrapper]',
		lineItem : '[data-line-item]',
		productQuantity : '[data-product-quantity]'
	};

	var WORDING = {
		unavailable : 'n\'est plus disponible dans cette taille'
	};
	/**
	* Bundle section constructor. Runs on page load as well as Theme Editor
	* `section:load` events.
	* @param {string} container - selector for the section container DOM element
	*/
	function Bundle(container) {
		this.$container = $(container);

		if (!$(selectors.productJson, this.$container).html()) {
			return;
		}

		var sectionId = this.$container.attr('data-section-id');
		this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
		this.imagesObject = product_images;

		var options = {
			$container: this.$container,
			enableHistoryState: this.$container.data('enable-history-state') || false,
			singleOptionSelector: selectors.singleOptionSelector,
			originalSelectorId: selectors.originalSelectorId,
			product: this.productSingleObject
		};

		this.cards = [];
		this.productPriceArray = [];
		this.settings = {};
		this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
		this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
		slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

		this.namespace = '.product-bundle';
		this.initCards();
		this.initHandlers();
		this.initImages();
		this.parseUrl();
		this.setDeliveryDate();
		$('[data-special-color]').each(function(){
			if($(this).children().length <= 0) $(this).prev().hide();
		});
	}

	Bundle.prototype = $.extend({}, Bundle.prototype, {

		initHandlers : function(){
            $(selectors.checkoutButton).attr("data-disabled", true);
			var self = this;
			// $(selectors.cardPlus).click(function(){
			// 	$(selectors.card).each(function(){
			// 		self.closeCard($(this));
			// 	})
			// 	self.openCard($(this).parents(selectors.card));
			// });
			// $(selectors.cardMinus).click(function(){
			// 	self.closeCard($(this).parents(selectors.card));
			// });
			$(selectors.cardToggle).click(function(){
				// console.log('Toggle card');
				if($(this).parents('[data-card]').hasClass('card--open')){
					// console.log('Close card');
					self.closeCard($(this).parents(selectors.card));
				}else{
					// console.log('Open card');
					$(selectors.card).each(function(){
						self.closeCard($(this));
					})
					self.openCard($(this).parents(selectors.card));
				}
			});

			$(selectors.cardOptionTrigger).click(function(){
				$(this).parents(selectors.optionContainer).find(selectors.cardOptionTrigger).each(function(){
					$(this).removeClass('selected');
				})
				$(this).addClass('selected');
				self.updateCardState($(this).parents(selectors.card).attr('data-card-index'));
			});
			$(selectors.productQuantity).change(function(){
				self.updateGeneralState();
			});
			$(selectors.checkoutButton).click(function(e){
				e.preventDefault();
				if($(this).attr("data-disabled") == 'true' || $(this).attr("data-disabled") == true){
					$(selectors.checkoutInfo).show();
				}else{
					$(this).parents('form').submit();
				}
			})
		},
		// About card state
		initCards : function(){
			var self = this;
			var index = 0;
			$(selectors.cardJson).each(function(){
				var cardJson = JSON.parse($(this, this.$container).html());
				self.cards.push({
					product : cardJson,
					variant : null,
					isValid : false,
					index : index,
					selector : '[data-card-product="' + cardJson.id + '"]'
				});
				index++;
			});
		},
		updateCardState : function(index){
			var card = this.cards[index];
			//console.log('Card : ', card);

			// Récupère les variantes de la card
			var variantObject = {};
			$(card.selector).find(selectors.optionContainer).each(function(){
				var optionName = $(this).attr('data-option-container');
				variantObject[optionName] = null;
				$(this).find(selectors.cardOption).each(function(){
					if($(this).hasClass('selected')){
						variantObject[optionName] = $(this).attr('data-option');
						if(optionName == 'Color'){
							// console.log("Swatch color")
							$(card.selector + ' ' + selectors.variantText).html(' : ' + variantObject[optionName]);
							// if($(this).parent().get(0).hasAttribute('data-special-color')){
							// 	console.log('test')
							// 	$(card.selector + ' ' + selectors.variantText).hide();
							// 	$('[data-special-color]').prev().find(selectors.variantText).show();
							// }else{
								// console.log('test2')
								$(card.selector + ' ' + selectors.variantText).show();
								// $('[data-special-color]').prev().find(selectors.variantText).hide();
							// }
						}
					}
				});
			});
			// Modifie l'objet card
			for(var i = 0; i < card.product.variants.length; i++){
				var variant = card.product.variants[i];
				if((variant.options[0] == variantObject[card.product.options[0]] && variant.options[1] == variantObject[card.product.options[1]])
				|| (variant.options[0] == variantObject[card.product.options[1]] && variant.options[0] == variantObject[card.product.options[1]])){
					card.variant = variant;
					if(variant.available == true){
						card.isValid = true;
						$(card.selector + ' ' + selectors.variantUnavailable).hide();
					}
					else{
						$(card.selector + ' ' + selectors.variantUnavailable).show();
						card.isValid = false;
					}
				}
			}

			// Change variables in header
			$(card.selector).find(selectors.cardOptionValue).each(function(){
				var option_name = $(this).attr('data-card-option');
				if(option_name == 'Color'){
					if(variantObject[option_name]){
						var background_image = $('[data-option="' + variantObject[option_name] + '"] .swatch-color__icon').css('background-image');
						//	background_image = background_image.replace(/.*\s?url\([\'\"]?/, '').replace(/[\'\"]?\).*/, '');
						//console.log('Background-image : ', background_image);
						if(background_image) $(this).find('.swatch-color__icon').css('background-image', background_image);
						else $(this).find('.swatch-color__icon').css('background-color', 'transparent');

					}else{
						$(this).find('.swatch-color__icon').css('background-color', 'transparent');
					}
				}else{
					if(variantObject[option_name]){
						$(this).html(variantObject[option_name]);
					}else{
						$(this).html('');
					}
				}
			});

			// Gére les affichages concernant les stocks. Impossible si + de 2 options
			if(card.product.options.length == 2){
				var count = 0;
				$(card.selector + ' ' + selectors.optionContainer).each(function(){
					$(this).find(selectors.cardOptionTrigger).each(function(){
						if($(this).hasClass('selected')){
							var selectedOption = $(this).attr('data-option');
							$(card.selector + ' ' + selectors.cardOption).each(function(){
								var option = $(this).attr('data-option');
								for(var i = 0; i < card.product.variants.length; i++){
									var variant = card.product.variants[i];
									if((variant.option1 == selectedOption && variant.option2 == option) ||
										(variant.option2 == selectedOption && variant.option1 == option)){
										if(variant.available){
											$(this).removeClass('unavailable');
										}else{
											$(this).addClass('unavailable');
										}
									}
								}
							});
						}
					})
				})
			}
			// Open next
			if(card.isValid){
				var next = 0;
				var next = parseInt(index) + 1;
				//$('[data-card-index="' + next + '"] [data-card-toggle]').click();
				$(card.selector).parents('.card__wrapper').find(selectors.cardPoint).addClass('card__point--validated');
			}else{
				$(card.selector).parent().find(selectors.cardPoint).removeClass('card__point--validated');
			}
			// console.log('Variant object : ', variantObject);
			// console.log('Card after : ', card);

			// Update product image
			if(variantObject['Color']){
				this.destroyImageSlider();
				this.destroyPopupSlider();
				this.buildImageSlider(variantObject['Color']);
				this.buildPopupSlider(variantObject['Color']);
			}

            // Update general state
			this.updateGeneralState();
			// TODO : si la carte est validée, cocher le rond comme validé et ouvrir la suivante.
		},
		openCard : function(card){
			var self = this;
			if(!card.hasClass('card--open')){
				card.addClass('card--open');
				//console.log('Open card ', card);
				card.find('[data-option-container="Color"] [data-card-option-trigger]').each(function(){
					if($(this).hasClass('selected')){
						self.destroyImageSlider();
						self.destroyPopupSlider();
						self.buildImageSlider($(this).attr('data-option'));
						self.buildPopupSlider($(this).attr('data-option'));
					}
				})
			}
		},
		closeCard : function(card){
			if(card.hasClass('card--open')){
				card.removeClass('card--open');
			}
		},

		// About general state
		updateGeneralState : function(){

			// Activate button and update price
			var self = this;
			var areValid = true;
			var totalPrice = 0;
			var calculPrice = true;
			var quantity = $(selectors.productQuantity).val();
			for(var i = 0; i < this.cards.length; i++){
				var card = this.cards[i];
				if(!card.isValid) areValid = false;
				if(card.variant) totalPrice += parseInt(card.variant.price);
				else calculPrice = false;
			}
			var productPrice = Math.ceil(0.9 * (totalPrice / 100));
			productPrice *= 100;
			// Update line item
			var foundLineItem = false;
			// console.log('Card : ', card.variant);
			$('[data-product-price="' + productPrice + '"]').each(function(){
				foundLineItem = true;
			});
			if(!foundLineItem) console.log('Problem : didnt found line item. Verify the setup from the backoffice');

			// Update add to cart button and price
			if(areValid && foundLineItem){
				$(selectors.checkoutAdd).show();
				$(selectors.checkoutDisabled).hide();
				// $(selectors.checkoutButton).removeClass('button--reverse');
				$(selectors.checkoutButton).attr("data-disabled", false);
				$(selectors.checkoutInfo).hide();
			}else{
				$(selectors.checkoutAdd).hide();
				$(selectors.checkoutDisabled).show();
				// $(selectors.checkoutButton).addClass('button--reverse');
				$(selectors.checkoutButton).attr("data-disabled", true);
			}
			var bundlePrice = productPrice * quantity;
			// console.log('Quantity : ', quantity);
			// console.log('Price : ', bundlePrice);
			if(calculPrice)	$(selectors.bundlePrice).html((bundlePrice / 100) + ',00€');
			else $(selectors.bundlePrice).html($(selectors.priceWrapper).attr('data-ref-price'));

			// Update URL
			this.updateUrl();


			$(selectors.lineItemsWrapper).html('');

			// Update line item
			if(areValid){
				// En premier et pour prévenir de toute erreur humaine dans le backoffice, on force à trouver un prix.
				var condensateVariantsName = '';
				for(var i = 0; i < self.cards.length; i++){
					var card = self.cards[i];
					condensateVariantsName += card.variant.option2;
					if(i != (self.cards.length - 1)) condensateVariantsName += ' / ';
				}
				// console.log('Condensate variant name ' + condensateVariantsName);
				var validItem = false;
				$(selectors.productPrice).each(function(){
					if($(this).attr('data-product-price') == productPrice){
						// console.log('Same price');
						$(this).prop('selected', true);
						validItem = true;
						// console.log('First  :', $(this).html().trim(), 'Second :', condensateVariantsName.trim());
						if($(this).html().trim() == condensateVariantsName.trim()){
							// console.log("this is the good value ");
							return false;
						}
					}
				});
				if(!validItem){
					$('[data-add-to-cart]').html('Erreur')
										   .addClass('button--disabled');
				}

				// Puis, on ajoute les noms des produits, les options et les SKUS en line item
				for(var l = 0; l < self.cards.length; l++){
					var card = self.cards[l];
					// console.log('Line Item Card : ', card);
					$(selectors.lineItemsWrapper).append('<input data-line-item type="hidden" name="properties[' + card.product.title + ']" value="' + card.variant.title + '" >');
					$(selectors.lineItemsWrapper).append('<input data-line-item type="hidden" name="properties[_handle:' + card.product.title + ']" value="' + card.product.handle + '">');
					$(selectors.lineItemsWrapper).append('<input data-line-item type="hidden" name="properties[_SKU ' + card.product.title + ']" value="' + card.variant.sku + '">');

				}
			}
		},
		updateUrl : function(){
			var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname;
			var firstChar = '?';
			for(var i = 0; i < this.cards.length; i++){
				var card = this.cards[i];
				if(card.variant){
					newurl += firstChar + 'option' + i + '=' + card.variant.id;
					firstChar = '&';
				}
			}
			window.history.replaceState({path: newurl}, '', newurl);
		},
		parseUrl : function(){
			var params = this.getAllUrlParams();
			var urlOptionName = 'option';
			if(params.color){
				var color = decodeURI(params.color)
				// console.log("color: ", color)
				$('[data-card-index="2"] [data-option-container="Color"] [data-option]').each(function(){
					// console.log($(this).attr('data-option').toLowerCase(), ' color : ', color);
					if($(this).attr('data-option').toLowerCase() == color) $(this).click();
				})
				$('[data-card-index="1"] [data-option-container="Color"] [data-option]').each(function(){
					// console.log($(this).attr('data-option').toLowerCase(), ' color : ', color);
					if($(this).attr('data-option').toLowerCase() == color) $(this).click();
				})
				$('[data-card-index="0"] [data-option-container="Color"] [data-option]').each(function(){
					// console.log($(this).attr('data-option').toLowerCase(), ' color : ', color);
					if($(this).attr('data-option').toLowerCase() == color) $(this).click();
				})
			}
			for(var i = 0; i < 3; i++){
				if(params[urlOptionName + i]){
					var option_id = params[urlOptionName + i];
					var card = this.cards[i]
					var variants = card.product.variants;
					var product = card.product;
					for(var j = 0; j < variants.length; j++){
						var variant = variants[j];
						if(variant.id == option_id){
							var isFounded = false;
							for(var k = 0; k < variant.options.length; k++){
								var optionName = product.options[k];
								if($(card.selector + ' [data-option-container="' + optionName + '"]').find('[data-option="' + variant.options[k] + '"]').length){
									$(card.selector + ' [data-option-container="' + optionName + '"]').find('[data-option="' + variant.options[k] + '"]').click();
									isFounded = true;
								}
							}
							if(!isFounded) continue;
							// Click on
							var next = i + 1;
							if(!params[optionName + next]){
								$('[data-card-index="' + i + '"] [data-card-toggle]').click();
								if(variant.available) $('[data-card-index="' + next + '"] [data-card-toggle]').click();
							}
						}
					}
				}
			}
		},
		// About image and popup image
		initImages : function(){
			this.initImageSlider();
			this.initPopupSlider();
			$(selectors.showPopupSlider).click(this.showPopupSlider.bind(this));
			$(selectors.hideImagePopup).click(this.hidePopupSlider.bind(this));
		},
		initImageSlider : function(){
			var self = this;

			this.$productSlider = $(selectors.productSlider).flickity({
				wrapAround : true, imagesLoaded: true, "pageDots": true , "groupCells": 1, "contain" : true, "cellAlign": "left", "arrowShape" : {"x0":30,"x1":60,"y1":25,"x2":65,"y2":25,"x3":35}
			});

			this.$productSlider.on('ready.flickity', function(){
				self.$productSlider.resize();
				$(selectors.productSlider).css('opacity', 1);
				$(selectors.productThumbnail).css('opacity', 1);
				setTimeout(function(){

				}, 100)
			});

			this.$productThumbnail = $(selectors.productThumbnail).flickity({
				asNavFor : '.product__slider',
				prevNextButtons: false,
				pageDots : false,
				groupCells: true
			});
			$(selectors.showPopupSlider).click(this.showPopupSlider.bind(this));
			$(selectors.hideImagePopup).click(this.hidePopupSlider.bind(this));
		},
		destroyImageSlider : function(){
			$(selectors.productSlider).css('opacity', 0);
			$(selectors.productThumbnail).css('opacity', 0);

			if(this.$productSlider.flickity){
				this.$productSlider.flickity('destroy');
			}
			this.$productSlider.html('');
			if(this.$productThumbnail.flickity){
				this.$productThumbnail.flickity('destroy');
			}
			this.$productThumbnail.html('');
		},
		buildImageSlider : function(color){
			var image, sliderHtml = '', thumbnailHtml = '';
			for(var i = 0; i < this.imagesObject.length; i++){
				image = this.imagesObject[i];
				if((image.alt.indexOf(color) !== -1 || image.alt.indexOf('multi') !== -1) && (color !== 'Juste Le Bleu' || (color === 'Juste Le Bleu' && image.alt.indexOf('Juste Le Bleu Gris') == -1)) && (color !== 'Juste Le Rayé' || (color === 'Juste Le Rayé' && image.alt.indexOf('Juste Le Rayé Sable') == -1)) && (color !== 'Juste Le Rayé' || (color === 'Juste Le Rayé' && image.alt.indexOf('Juste Le Rayé Bleu') == -1))){
					sliderHtml += '<div class="carousel-cell full-width"><img class="product__slider-image" data-show-image-popup src="' + image.src + '" alt="' + image.alt + '"></div>';
					thumbnailHtml += '<div class="carousel-cell"><div class="thumbnail thumbnail--circled" style="background-image:url('+ image.src + ')"></div></div>';
				}
			}
			this.$productSlider.html(sliderHtml);
			this.$productThumbnail.html(thumbnailHtml);
			this.initImageSlider();
		},

		initPopupSlider : function(){
			var self = this;

			this.$popupSlider = $(selectors.popupSlider).flickity({
				 sync:'.product__slider',wrapAround : true, imagesLoaded: true, "pageDots": true , "groupCells": 1, "contain" : true, "cellAlign": "left", "arrowShape" : {"x0":30,"x1":60,"y1":25,"x2":65,"y2":25,"x3":35}
			});

			this.$popupSlider.on('ready.flickity', function(){
				self.$popupSlider.resize();
				$(selectors.popupSlider).css('opacity', 1);
				$(selectors.popupThumbnail).css('opacity', 1);
			});

			this.$popupThumbnail = $(selectors.popupThumbnail).flickity({
				asNavFor : '.product__slider--popup',
				prevNextButtons: false,
				pageDots : false,
				groupCells: true
			});
			$('.product__popup').click(function(event){event.stopPropagation();})
		},
		buildPopupSlider : function(color){
			var image, sliderHtml = '', thumbnailHtml = '';
			for(var i = 0; i < this.imagesObject.length; i++){
				image = this.imagesObject[i];
				if((image.alt.indexOf(color) !== -1 || image.alt.indexOf('multi') !== -1) && (color !== 'Juste Le Bleu' || (color === 'Juste Le Bleu' && image.alt.indexOf('Juste Le Bleu Gris') == -1)) && (color !== 'Juste Le Rayé' || (color === 'Juste Le Rayé' && image.alt.indexOf('Juste Le Rayé Sable') == -1)) && (color !== 'Juste Le Rayé' || (color === 'Juste Le Rayé' && image.alt.indexOf('Juste Le Rayé Bleu') == -1))){
					sliderHtml += '<div class="carousel-cell full-width"><img class="product__slider-image" src="' + image.src + '" alt="' + image.alt + '"></div>';
					thumbnailHtml += '<div class="carousel-cell"><div class="thumbnail thumbnail--circled" style="background-image:url('+ image.src + ')"></div></div>';
				}
			}
			this.$popupSlider.html(sliderHtml);
			this.$popupThumbnail.html(thumbnailHtml);
			this.initPopupSlider();
		},
		destroyPopupSlider : function(){
			$(selectors.popupSlider).css('opacity', 0);
			$(selectors.popupThumbnail).css('opacity', 0);

			if(this.$popupSlider.flickity){
				this.$popupSlider.flickity('destroy');
			}
			this.$popupSlider.html('');
			if(this.$popupThumbnail.flickity){
				this.$popupThumbnail.flickity('destroy');
			}
			this.$popupThumbnail.html('');
		},
		hidePopupSlider : function(){
			$('.product__popup-container').removeClass('product__popup-container--activated');
		},
		showPopupSlider : function(){
			//console.log('Show popup slider', this.$productSlider.selectedIndex);
			this.$popupSlider.flickity( 'selectCell', this.$productSlider.selectedIndex);

			$('.product__popup-container').addClass('product__popup-container--activated');
		},

		// Tools
		getAllUrlParams : function(url){
			// get query string from url (optional) or window
			var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
			// we'll store the parameters here
			var obj = {};
			// if query string exists
			if (queryString) {
				// stuff after # is not part of query string, so get rid of it
				queryString = queryString.split('#')[0];
				// split our query string into its component parts
				var arr = queryString.split('&');
				for (var i = 0; i < arr.length; i++) {
					// separate the keys and the values
					var a = arr[i].split('=');
					// set parameter name and value (use 'true' if empty)
					var paramName = a[0];
					var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];
					// (optional) keep case consistent
					paramName = paramName.toLowerCase();
					if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();
					// if the paramName ends with square brackets, e.g. colors[] or colors[2]
					if (paramName.match(/\[(\d+)?\]$/)) {
						// create key if it doesn't exist
						var key = paramName.replace(/\[(\d+)?\]/, '');
						if (!obj[key]) obj[key] = [];
						// if it's an indexed array e.g. colors[2]
						if (paramName.match(/\[\d+\]$/)) {
							// get the index value and add the entry at the appropriate position
							var index = /\[(\d+)\]/.exec(paramName)[1];
							obj[key][index] = paramValue;
						} else {
							// otherwise add the value to the end of the array
							obj[key].push(paramValue);
						}
					} else {
						// we're dealing with a string
						if (!obj[paramName]) {
							// if it doesn't exist, create property
							obj[paramName] = paramValue;
						} else if (obj[paramName] && typeof obj[paramName] === 'string'){
							// if property does exist and it's a string, convert it to an array
							obj[paramName] = [obj[paramName]];
							obj[paramName].push(paramValue);
						} else {
							// otherwise add the property
							obj[paramName].push(paramValue);
						}
					}
				}
			}
			return obj;
		},
		setDeliveryDate:function(){
			var date = new Date();
			var isWeekend = date.getDay()%6==0;
			var hours = date.getHours();
			if(isWeekend || hours > 12){
				var nextDay = new Date(date);
					nextDay.setDate(date.getDate() + 1);
				var nextDayString = nextDay.toLocaleString('fr', {  weekday: 'long' });
				var nextDateString = nextDay.toLocaleString('fr', {  weekday: 'long', day : 'numeric', month : 'long' });
				if(nextDayString == 'samedi' || nextDayString == 'dimanche'){
					var nextMonday = new Date();
						nextMonday.setDate(nextMonday.getDate() + (1 + 7 - nextMonday.getDay()) % 7);
					var nextMondayString = nextMonday.toLocaleString('fr', {  weekday: 'long', day : 'numeric', month : 'long' });
					$('[data-delivery-date]').html(nextMondayString);
				}else{
					$('[data-delivery-date]').html(nextDateString);
				}
			}else{
				$('[data-delivery-date]').html('aujourd\'hui');
			}
		}
	});

	return Bundle;
})();


/** instagram feed **/

theme.instagramFeed = new function() {

	var settings = {};

	function instagramFeed(userSettings) {
		var defaultSettings = {
			get: 'user',
			userId: null,
			limit: 9,
			resolution: 'standard_resolution',
			accessToken: null,
			template: '\
			<div class="instafeed__block-image grid__cell 1/3--lap-and-up 1/2--portable">\
				<a target="_blank" href="{{link}}">\
					<img class="instagram-image" src="{{image}}" />\
				</a>\
			</div>'
		};
		settings = $.extend({}, defaultSettings, userSettings);
	}

	instagramFeed.prototype.init = function() {
		var userFeed = new Instafeed(settings);
		return userFeed;
	}

	instagramFeed.prototype.run = function(userFeed) {
		userFeed.run();
	}

	return instagramFeed;
}

var instagramFeedSettings = {
	userId: $('.instagram__container').data('user-id'),
	accessToken: $('.instagram__container').data('access-token')
}

// if instafeed exist, init construcor
if ($('.instagram__container').length) {
	var instaFeed = new theme.instagramFeed(instagramFeedSettings);
	var userFeed = instaFeed.init();
	instaFeed.run(userFeed);
}
$(function () {
	var speed = $('.concept__image-block').attr('data-slide-speed');
	var nextImg = null;
	var currentImg = null;

	var changeSlide = function () {
		currentImg = $('.concept__image.concept__image--activated');
		nextImg = currentImg.next('.concept__image');
		if (nextImg.length == 0) {
			nextImg = $('.concept__image-block').children().first();
		}
		nextImg.addClass('concept__image--activated');
		currentImg.removeClass('concept__image--activated');

		$('.keyword_text b span').html(nextImg.attr('data-keyword'));
	}
	$('.keyword_text b').append('<span></span>');
	changeSlide();
	setInterval(changeSlide, speed);
});

$(function(){
	var speed = $('.banner-concept__image-block').attr('data-slide-speed');
	var nextImg = null;
	var currentImg = null;

	var changeSlide = function(){
		currentImg = $('.banner-concept__image.banner-concept__image--activated');
		nextImg = currentImg.next('.banner-concept__image');
		if (nextImg.length == 0) {
			nextImg = $('.banner-concept__image-block').children().first();
		}

		currentImg.removeClass('banner-concept__image--activated');
		nextImg.addClass('banner-concept__image--activated');

		$('.keyword_text b span').html(nextImg.attr('data-keyword'));
	}
	$('.keyword_text b').append('<span></span>');
	changeSlide();
	setInterval(changeSlide, speed);
});

var $conceptMenu = $('.anchor-menu');

var topbarVisibility = Cookies.get('topbarVisibility');
if ($(window).scrollTop() == 0 && !topbarVisibility ) {
    $('[data-promo-banner]').removeClass('hide');
}

if($('.anchor-menu').length){
    $('.header__submobile').css('display','flex');
}
$('.anchor-menu__link').each(function(){
    $(this).clone().addClass('header__submobile--link').appendTo('.header__submobile');
    //$(this).hide();
});
$('[data-anchor-slideto]').click(function(){
    $conceptMenu.children('a').each(function () {
        $(this).removeClass('anchor-menu__selected');
    });
    $(this).addClass('anchor-menu__selected');
    var $targetElement = $('[data-anchor-id="' + $(this).attr('data-anchor-slideto') + '"]');
    if($targetElement.length > 1){
        $targetElement.each(function(){
            if($(this).is(':visible')){
                $targetElement = $(this);
                return false;
            }
        })
    }
    var heightSum = $('.header').height() + $conceptMenu.parent().height() + $('.header__submobile').height();
    if($(window).width() > 800) heightSum += 50;
    else heightSum -= 40;
    if($targetElement && $targetElement.offset())$("html, body").animate( { scrollTop: $targetElement.offset().top - heightSum}, 1500);
});
$(function(){
    var $selectedElement, $nextElement, $nextTop, $prevElement, $prevTop;
    $('#shopify-section-header').on('headerChange', function(){
        $('.anchor-section').css('top', $('.header').height() + 'px');
        setTimeout(function(){
            $('.anchor-section').css('top', $('.header').height() + 'px');
        }, 50);
        setTimeout(function(){
            $('.anchor-section').css('top', $('.header').height() + 'px');
        }, 100);
        setTimeout(function(){
            $('.anchor-section').css('top', $('.header').height() + 'px');
        }, 150);
        if($('.anchor-section').hasClass('anchor-menu__sticky')){
            $('.anchor-section').removeClass('anchor-menu__sticky');
        }else{
            $('.anchor-section').addClass('anchor-menu__sticky');
            if ($('[data-promo-banner]').is(':visible'))
                $('[data-promo-banner]').addClass('hide');
            else if (!Cookies.get('topbarVisibility')) {
                $('[data-promo-banner]').removeClass('hide');
            }
        }
    })
    $(window).on('scroll', function(){
        $('.anchor-section').css('top', $('.header').height() + 'px');
        var top = $(window).scrollTop();
        var $selectedElement = $('.anchor-menu .anchor-menu__selected').first();
        if(!$selectedElement.length) $selectedElement = $('.anchor-menu__link').first();
        var $selectedTop = $selectedElement.scrollTop();
        var $nextElement = $selectedElement.next('.anchor-menu__link');
        if(!$nextElement.is(':visible')){
            $nextElement = $nextElement.next('.anchor-menu__link');
        }
        if($nextElement.length){
            if(!$('[data-anchor-id="' + $nextElement.attr('data-anchor-slideto') + '"]').offset()) return;
            var $nextTop = $('[data-anchor-id="' + $nextElement.attr('data-anchor-slideto') + '"]').offset().top;
            if($nextTop - 300 < top){
                $selectedElement.removeClass('anchor-menu__selected');
                $nextElement.addClass('anchor-menu__selected');
            }
        }
        var prevElement = $selectedElement.prev('.anchor-menu__link');
        if(!prevElement.is(':visible')) prevElement = prevElement.next('.anchor-menu__link');
        if(prevElement.length){
            var prevTop = $('[data-anchor-id="' + prevElement.attr('data-anchor-slideto') + '"]').offset().top;
            if(prevTop > top){
                $selectedElement.removeClass('anchor-menu__selected');
                prevElement.addClass('anchor-menu__selected');
            }
        }
    })
});

// =require sections/anchor-menu.js
// =require sections/reviews.js
$(function(){
	$('[data-swatch-change]').click(function(){
		var color = $(this).attr('data-color');
		var $new_color_elt = $(this).parents('.product-card').find('[data-image-color="' + color + '"]');
		// console.log('Color : ', color);
		$(this).parents('.product-card').find('[data-image-color]').each(function(){
			$(this).removeClass('selected')
		});
		$new_color_elt.addClass('selected');
		$(this).parents('.product-card').find('[data-swatch-change]').each(function(){
			$(this).removeClass('selected')
		});
		// console.log($new_color_elt.attr('data-link-value'));
		$(this).parents('.product-card').find('[data-product-link]').attr('href', $new_color_elt.attr('data-link-value'));
		$(this).addClass('selected')
	});

	if($(window).width() > 787){
		$('[data-swatch-change]').mouseover(function() {
			var color = $(this).attr('data-color');
			$(this).parents('.product-card').find('.product-card__images-color.selected').hide();
			$(this).parents('.product-card').find('[data-image-color="' + color + '"]').show();
		}).mouseout(function() {
			var color = $(this).attr('data-color');
			$(this).parents('.product-card').find('[data-image-color="' + color + '"]').hide();
			$(this).parents('.product-card').find('.product-card__images-color.selected').show();
		});
	}
	$('[data-card-bundle] [data-swatch-change]').each(function(){
		if($(this).hasClass('selected')){
			$(this).click();
		}
	});
})

$('.details-card__button-toggle').on('click', function() {
    // console.log($(this).find('svg:first').css("transform"));
    if($(window).width() < 787){
        if ($(this).find('svg:first').css("transform") == "none") {
            $(this).find('svg:first').css("transform", "rotate(90deg)");
        } else {
            $(this).find('svg:first').css("transform", "none");
        }
        $(this).parent().parent().find('.details-card__toggle').slideToggle();
    }
});

$(function () {
	var currentKeywordPosition = 0;
	var speed = $('.banner-avis').attr('data-avis-speed');
	if ($('.banner-avis__title').attr('data-avis-keywords') != undefined) {
		var arrayKeywords = $('.banner-avis__title').attr('data-avis-keywords').split(',');
		if (arrayKeywords[0] != null && arrayKeywords[0] != undefined) {
			var arrayKeywordsLength = arrayKeywords.length;
			var changeKeyword = function () {
				$('.banner-avis__title b').html(arrayKeywords[arrayKeywordsLength - 1]+'<span>'+arrayKeywords[currentKeywordPosition]+'</span>');
				if (currentKeywordPosition < arrayKeywordsLength - 1) {
					currentKeywordPosition++;
				} else {
					currentKeywordPosition = 0;
				}
			}
			changeKeyword();
			setInterval(changeKeyword, speed);
		}
	}
});
theme.accordion = (function () {
    'use strict';

    var selectors = {
        root   : "[data-accordion]",
        trigger: "[data-accordion-trigger]",
        panel  : "[data-accordion-panel]"
    }

    var features = {
        allow_multiple : "[data-allow-multiple]",
        allow_toggle   : "[data-allow-toggle]"
    }

    var data = {
        target_id: 'aria-controls'
    }

    var states = {
        expanded: {
            attr_name: 'aria-expanded',
            attr_values : {
                yes: "true",
                no:  "false"
            }
        },
        disabled: {
            attr_name: 'aria-disabled',
            attr_values : {
                yes: "true",
                no:  "false"
            }
        }
    }

    $(selectors.root).each(function () {
        var $accordion = $(this);
        init($accordion);
    });

    function init ($accordion) {
        var allowsMultiple = $accordion.is(features.allow_multiple);
        var options = {
            allowsMultiple: allowsMultiple,
            allowToggle: (allowsMultiple) ? allowsMultiple : $accordion.is(features.allow_toggle)
        }

        $accordion.on("click", selectors.trigger, function (e) {
            e.preventDefault();
            trigger($(this), $accordion, options);
        });

        $accordion.on('keydown', function (e) {
            handleKeyboard(event, $(this), options);
        });

        if (!options.allowToggle) {
            // Get the first expanded/ active accordion
            var $expanded = $accordion.find('[aria-expanded="true"]').first();

            // If an expanded/ active accordion is found, disable
            if ($expanded.length) {
                $expanded.setAttribute(states.disabled.attr_name, states.disabled.attr_values.yes);
            }
        } else {
            // Get all unexpanded accordion panels
            var $unexpanded = $accordion.find('[aria-expanded="false"]');
            $unexpanded.each(function () {
                var panelId = $(this).attr('aria-controls');
                hidePanel ($(panelId))
            })
        }
    }

    function trigger ($trigger, $accordion, options) {
        var settings = {
            allowsMultiple: options.allowsMultiple,
            allowToggle   : options.allowToggle
        };

        var $targetPanel = $($trigger.attr(data.target_id));

        var isExpanded = $trigger.is("[" + states.expanded.attr_name + "='" + states.expanded.attr_values.yes + "']");
        var $accordionActiveTriggers = $accordion.find("[" + states.expanded.attr_name + "='" + states.expanded.attr_values.yes + "']");
        var $accordionActivePanels = $accordion.find(selectors.panel);

        if (!settings.allowsMultiple && $accordionActiveTriggers.length > 0) {
            // Set the expanded state on the triggering element
            $accordionActiveTriggers.not($trigger).attr(states.expanded.attr_name, states.expanded.attr_values.no);
            // Hide the accordion sections, using aria-controls to specify the desired section
            hidePanel($accordionActivePanels.not($targetPanel));

            // When toggling is not allowed, clean up disabled state
            if (!settings.allowToggle) {
                $accordionActiveTriggers.removeAttr(states.disabled.attr_name);
            }
        }

        if (!isExpanded) {
            // Set the expanded state on the triggering element
            $trigger.attr(states.expanded.attr_name, states.expanded.attr_values.yes);
            // Hide the accordion sections, using aria-controls to specify the desired section
            reveilPanel($targetPanel);

            // If toggling is not allowed, set disabled state on trigger
            if (!settings.allowToggle) {
                $trigger.attr(states.disabled.attr_name, states.disabled.attr_values.yes);
            }
        }
        else if (settings.allowToggle && isExpanded) {
            // Set the expanded state on the triggering element
            $trigger.attr(states.expanded.attr_name, states.expanded.attr_values.no);
            // Hide the accordion sections, using aria-controls to specify the desired section
            hidePanel($targetPanel);
        }
    }

    function reveilPanel ($panel) {
        $panel.slideDown();// .removeClass('hide');
    }

    function hidePanel ($panel) {
        $panel.slideUp(); //.addClass('hide');
    }

    function handleKeyboard (event, $accordion, options) {}
})();

$(function(){
    $('[data-anchor-id]').click(function(){
        $(this).toggleClass('faq-groupe__visible')
        var selectedTitle = 'mobile-' + $(this).attr('data-anchor-id');
        if($(window).width() > 800) return;
        $('[data-mobile-accordion]').each(function() {
            var childTitle = $(this).attr('data-mobile-accordion');
            if(selectedTitle == childTitle) {
                $(this).slideToggle();
            }
        })
    })
})
$(function(){
    if (Cookies.get('popupClose') == undefined || Cookies.get('popupClose') == false) {
        var speed = $('.popup').attr('data-popup-speed') * 1000;
        // console.log('Speed ' , speed);
        setTimeout(function() {
            $('[data-popup-background]').show();
        }, speed);
    }
    $('[data-popup-close]').click(function(){
        $('[data-popup-background]').hide();
        Cookies.set('popupClose', true);
    })

    $('.popup #Subscribe').click(function(){
        Cookies.set('popupClose', true);
        // console.log('SET');
        if(typeof ga !== 'undefined') {
            console.log("add mail popup made")
            ga('create', 'UA-110071462-1', 'auto');
            ga('send', {
              hitType: 'event',
              eventCategory: 'Newsletter',
              eventAction: 'AddMail',
              eventLabel: 'AddMailPopup'
            });
        }
    });
    $('footer .newsletter__submit').click(function(e){
        if(typeof ga !== 'undefined') {
            console.log("add mail footer made")
            ga('create', 'UA-110071462-1', 'auto');
            ga('send', {
                hitType: 'event',
                eventCategory: 'Newsletter',
                eventAction: 'AddMail',
                eventLabel: 'AddMailFooter'
            });
        }
    });

    $('[data-popup-close-btn]').click(function(){
        Cookies.set('popupClose', true);
        $('[data-popup-background]').hide();
    });
})

var activateSideCart = window.deactivate_side_cart == true? false:true;

function getFormData($form){
    var unindexed_array = $form.serializeArray();
    var indexed_array = {};

    $.map(unindexed_array, function(n, i){
        if (activateSideCart && n['name'].includes('properties')) {
            indexed_array[n['name'].split('[').pop().split(']')[0]] = n['value'];
        } else {
            indexed_array[n['name']] = n['value'];
        }
    });

    return indexed_array;
}

function addProduct(data, scrollTop) {
    // console.log(scrollTop);
    $("[data-cart-items-content]").addClass("hide");
    $("[data-cart-loading]").removeClass("hide");

    if (activateSideCart) {

        var clone = Object.assign({}, data);
        delete clone.id;
        delete clone.quantity;


        if (clone.hasOwnProperty('properties')) {
            clone = Object.assign(clone, clone.properties);
        }

        // console.log(clone);

        for (const [key, value] of Object.entries(clone)) {
            if (key == "Color" || key == "Taille") {
                var propertyName = "_"+ key;
                clone[propertyName] = value;
                delete clone[key];
            }
        }
        // console.log("Clone final: ", clone);

        CartJS.addItem(data.id, data.quantity, clone, {
            "success": function(data, textStatus, jqXHR) {

                //open side cart
                $(window).trigger('closeSearch')

                if ($('body').hasClass('template-cart')) return;

                $("body").addClass("non-scroll");
                $(".header").addClass("not-light");
                $("[data-cart-background-overlay]").addClass("active");
                $("[data-side-cart]").addClass("open");

                if (scrollTop != undefined) {
                    $("[data-side-cart]").animate({scrollTop: $("[data-side-cart]").offset().top});
                }
            }
        });

    } else {

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: data,
            success: function() {
                // console.log("Data: "+ JSON.stringify(data));
                location.href = '/cart';
            },
            error: function(err) {
                console.log("Erreur: "+ err);
                // TODO: Regarder si le produit à une broderie + la supprimer
            }
        });
    }
}

function addGiftProduct(id, quantity) {
    if (quantity > 10) quantity = 10;
    CartJS.addItem(id, quantity, {"_gift" : "gift"}, {
        "success": function() {
            $('[data-cart-gift]').removeClass('side-cart-gift-open');
            $('#cart-gift-container').addClass('hide');
        }
    });
}

if ($('[data-product-carousel]') != undefined) {
    var $carousel = $('[data-broderie-carousel]').flickity(
        {
            "pageDots": true,
            "prevNextButtons": true,
            "draggable": true,
            "adaptiveHeight": false,
            "arrowShape" : {"x0":30,"x1":60,"y1":25,"x2":65,"y2":25,"x3":35}
        }
    );

      // Flickity instance
    var flkty = $carousel.data('flickity');

    // Fix for lazyload + flickity -- Mac retina
    $('[data-broderie-carousel-container]').find('img').each(function(){$(this).on('load',
        function(){
            $carousel.resize();
            $carousel.find('.flickity-viewport').height($carousel.find('.carousel-cell').first().height() + 'px');
        })
    });

    // elements
    var $cellButtonGroup = $('[data-broderie-group-cells]');
    var $cellButtons = $cellButtonGroup.find('[data-broderie-button]');

    // update selected cellButtons
    $carousel.on( 'select.flickity', function() {
        $cellButtons.filter('.is-selected')
        .removeClass('is-selected');
        $cellButtons.eq( flkty.selectedIndex )
        .addClass('is-selected');
    });

    // select cell on button click
    $cellButtonGroup.on( 'click', '[data-broderie-button]', function() {
        var index = $(this).index();
        $carousel.flickity( 'select', index );
    });

}

function addProductBroderie(id, variant, quantity, data) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            id: variant,
            quantity: quantity,
            properties: {
                '_ID': id
            }
        },
        success: function(item) {
            var key = item.key;
            var handle = item.handle;
            var variant_id = item.variant_id;
            // data["properties"]["ID"] = id;
            data["properties"]["_Token"] = key;
            data["properties"]["_Ref"] = handle+"#"+variant_id;
            data["properties"]["_Price"] = item.price;
            addProduct(data)
        },
        error: function(err) {
            console.log("Erreur: "+ err);
        }
    });
}

function getCurrentPrice() {
    var currentPriceBroderie = $('[data-bundle-price]').html();
    var currentPrice = $('[data-price-wrapper] h2').html();
    if (currentPriceBroderie != undefined) {
        var currentPriceBroderie = currentPriceBroderie.split(",");
        var currentPriceBroderie = currentPriceBroderie[0];
        return currentPriceBroderie;
    } else if (currentPrice != undefined) {
        var currentPrice = currentPrice.split(",");
        var currentPrice = currentPrice[0];
        return currentPrice;
    }
    return 0;
}

function formatBroderiePrice(broderiePrice) {
    var price = broderiePrice.split(",");
    var price = price[0];
    return price;
}

$(function () {
    var broderieText;
    var broderieText2;
    var broderieColor;
    var productVariantId;
    var currentProductPrice = 0;

    // SHOW BUTTON BRODERIE
    if ($(".broderie__texts")[0]){
        $('[data-open-broderie]').css("display", "inline-block");
        $("#broderie-color-1").attr('checked', true);
    }

    // SHOW BRODERIE
    $('[data-open-broderie]').on('click', function(){
        if(typeof ga !== 'undefined') {
            console.log("add mail popup made")
            ga('create', 'UA-110071462-1', 'auto');
            ga('send', {
              hitType: 'event',
              eventCategory: 'Broderie',
              eventAction: 'OpenPopup',
              eventLabel: 'OpenBroderiePopup'
            });
        }
        var quantity = $('[data-product-quantity]').val()
        currentProductPrice = getCurrentPrice();
        $('[data-broderie-button-price],[data-broderie-product-price]').html(' - '+ currentProductPrice + '€');
        $('[data-broderie-product-price]').html(currentProductPrice + '€');
        $('[data-broderie-price]').html('0€');
        $('[data-broderie-quantity]').text(quantity);
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        $('body').css("overflow", "hidden");
        $('.header').css("position", "fixed !important");
        $('[data-broderie]').addClass('broderie-open');
        $('[data-valid-broderie]').prop("disabled", false);
        $('.header').css("position", "inherit");
    });

    // CLOSE BRODERIE
    $('[data-close-broderie]').on('click', function(){
        $('body').css("overflow", "unset");
        $('[data-broderie]').removeClass('broderie-open');
        $('[data-broderie-text1],[data-broderie-text2]').val("");
    });

    // CHANGE INPUT FONT
    $("input[name='broderie-font']").click(function() {
        $('[data-broderie-text1]').css('font-family', $(this).data('fontFamily'));
        $('[data-broderie-text2]').css('font-family', $(this).data('fontFamily'));
    });

    // CHANGE SPAN COLOR VALUE + VAR FINAL COLOR
    $("input[name='broderie-color']").click(function() {
        broderieColor = this.value;
        $('[data-broderie-color] span').text(this.value);
    });

    // DELETE ONE BRODERIE
    $('[data-broderie-delete]').on('click', function() {
        $(this).parent().hide()

        if ($('.broderie__resume-first').is(":visible") || $('.broderie__resume-second').is(":visible")) {
            productVariantId = $('[data-broderie-variant1]').val();
            $('[data-product-broderie]').val($('[data-broderie-variant]').val());
        }
        else if ($('.broderie__resume-first').is(":hidden") && $('.broderie__resume-second').is(":hidden")) {
            $('[data-product-broderie]').val("");
            $('.borderie__resume').hide();
        }
    });

    // ON FIRST INPUT CHANGE
    $('[data-broderie-text1]').on('keyup', function() {
        var quantity = $('[data-product-quantity]').val()
        // this.value = this.value.toUpperCase();
        if (this.value != "" && this.value != undefined) {

            if ($('[data-broderie-text2]').val() == "" || $('[data-broderie-text2]').val() == undefined){
                var broderiePrice = formatBroderiePrice($("[data-broderie-price1]").data('broderiePrice1'));
                var price = parseInt(currentProductPrice) + parseInt(broderiePrice * quantity);
                $('[data-broderie-button-price]').html(' - '+ price + '€');
                $('[data-broderie-price]').html(broderiePrice * quantity  + '€');
            }
            $('[data-broderie-text2]').prop( "disabled", false );
            $('[data-broderie-error]').hide();

        } else {

            $('[data-broderie-text2]').prop( "disabled", true );
            $('[data-broderie-error]').show();
            $('[data-broderie-button-price]').html(' - '+ currentProductPrice + '€');
            $('[data-broderie-price]').html('0€');
        }
    });

    $('[data-broderie-text2]').on('keyup', function() {
        var quantity = $('[data-product-quantity]').val()
        // this.value = this.value.toUpperCase();
        if (this.value == "" || this.value == undefined) {
            $(this).css("border-color", "#dedede");
        }
        if (this.value != "" && this.value != undefined) {
            var broderiePrice = formatBroderiePrice($("[data-broderie-price2]").data('broderiePrice2'));
            var price = parseInt(currentProductPrice) + parseInt(broderiePrice * quantity);
            $('[data-broderie-button-price]').html(' - '+ price + '€');
            $('[data-broderie-price]').html(broderiePrice * quantity + '€');
        } else if ($('[data-broderie-text1]').val() != "" && $('[data-broderie-text1]').val() != undefined) {
            var broderiePrice = formatBroderiePrice($("[data-broderie-price1]").data('broderiePrice1'));
            var price = parseInt(currentProductPrice) + parseInt(broderiePrice * quantity);
            $('[data-broderie-button-price]').html(' - '+ price+ '€');
            $('[data-broderie-price]').html(broderiePrice * quantity + '€');
        }
    });

    $( "[data-broderie-text2]" ).focus(function() {
        if ($('[data-broderie-text1]').val() != "" || $('[data-broderie-text1]').val() != undefined) {
            $(this).css("border-color", "black");
        }
    });

    // VALID BRODERIE
    $("body").on('click', '[data-valid-broderie]', function() {
        broderieText = $("input[name=broderie-text1]").val();
        broderieText2 = $("input[name=broderie-text2]").val();
        broderieColor = $("input[name=broderie-color]:checked").val();
        broderieFont = $("input[name=broderie-font]:checked").val();

        if (broderieText == "" || broderieText == undefined) {
            $('[data-broderie-error]').show();
        } else {
            $('[data-valid-broderie]').prop( "disabled", true );
            if ((broderieText != "" && broderieText != undefined)
                    && (broderieText2 != "" && broderieText2 != undefined)) {
                productVariantId = $('[data-broderie-variant2]').val();
            } else if ((broderieText != "" && broderieText != undefined)
                    || broderieText2 != "" && broderieText2 != undefined) {
                productVariantId = $('[data-broderie-variant1]').val();
            }

            if (broderieColor != "" && broderieColor != undefined) {
                $('[data-valid-broderie]').prop("disabled", false);
                if (broderieText != "" && broderieText != undefined) {
                    $('[data-broderie-resume1] span').text(broderieText);
                    // $('.borderie__resume, .broderie__resume-first').show();
                } else {
                    $('.broderie__resume-first').hide();
                }
                if (broderieText2 != "" && broderieText2 != undefined) {
                    $('[data-broderie-resume3] span').text(broderieText2);
                    // $('.borderie__resume, .broderie__resume-second').show();
                } else {
                    $('.broderie__resume-second').hide();
                }
                if ((broderieText == "" || broderieText == undefined)
                        && (broderieText2 == "" || broderieText2 == undefined)) {
                    $('[data-product-broderie]').val("");
                    // $('.borderie__resume').hide();
                    $("#product-page-form").submit();
                } else {
                    $('[data-product-broderie]').val(productVariantId);
                    $('[data-broderie-resume2] span').text(broderieColor);
                    $("#product-page-form").submit();
                }
            } else {
                alert("Erreur couleur");
            }
        }
    });

    // ON SUBMIT FORM WITH BRODERIE
    $('#product-page-form').on("submit", function(event) {
        event.preventDefault();

        var product = JSON.parse($('[data-product-json]').html());
        var variants = product.variants;
        var variantId = $("[data-product-select]").val();

        var broderieSKU = '';
        variants.forEach(function(item){
            if (item.id == variantId) {
                broderieSKU = item.sku;
            }
        });

        if ( typeof parure !== 'undefined' && parure == true ) {
            var isParure = true;
        } else {
            var isParure = false;
        }

        var random = Math.floor(Math.random() * 100000000) + 1;
        var $form = $("#product-page-form");
        var data = getFormData($form);
        var broderie = false;

        if (broderieColor != "" && broderieColor != undefined
                && broderieText != "" && broderieText != undefined
                && broderieText2 != "" && broderieText2 != undefined) {
            if (isParure) {
                data["properties"] = { '_TEXTE1': broderieText, '_TEXTE2': broderieText2, '_COULEUR1': broderieColor, '_COULEUR2': broderieColor, '_FONT': broderieFont, 'Broderie': broderieText + ' / ' + broderieText2 + ' / ' + broderieColor };
            } else {
                data["properties"] = { '_TEXTE1': broderieText, '_TEXTE2': broderieText2, '_COULEUR1': broderieColor, '_COULEUR2': broderieColor, '_FONT': broderieFont, '_SKU': broderieSKU, 'Broderie': broderieText + ' / ' + broderieText2 + ' / ' + broderieColor };
            }
            broderie = true;
        } else if (broderieColor != "" && broderieColor != undefined
                && broderieText != "" && broderieText != undefined) {
            if (isParure) {
                data["properties"] = { '_TEXTE1': broderieText, '_COULEUR1': broderieColor, '_FONT': broderieFont, 'Broderie': broderieText + ' / ' + broderieColor  };
            } else {
                data["properties"] = { '_TEXTE1': broderieText, '_COULEUR1': broderieColor, '_FONT': broderieFont, '_SKU': broderieSKU, 'Broderie': broderieText + ' / ' + broderieColor  };
            }
            broderie = true;
        } else if (broderieColor != "" && broderieColor != undefined
                && broderieText2 != "" && broderieText2 != undefined) {
            if (isParure) {
                data["properties"] = { '_TEXTE1': broderieText2, '_COULEUR1': broderieColor, '_FONT': broderieFont, 'Broderie': broderieText2 + ' / ' + broderieColor  };
            } else {
                data["properties"] = { '_TEXTE1': broderieText2, '_COULEUR1': broderieColor, '_FONT': broderieFont, '_SKU': broderieSKU, 'Broderie': broderieText2 + ' / ' + broderieColor  };
            }
            broderie = true;
        }

        var variant = productVariantId;
        var quantity = data['quantity'];

        if (broderie) {
            $('[data-broderie-text1],[data-broderie-text2]').val("");
            broderieText = "";
            broderieText2 = "";
            broderieColor = "";
            addProductBroderie(random, variant, quantity, data);
        } else {
            addProduct(data);
        }
        $('body').css("overflow", "unset");
        $('[data-broderie]').removeClass('broderie-open');
        $('[data-broderie-text1],[data-broderie-text2]').val("");
    })
});

theme.cart = new function () {

    var settings = {};

    function cart(cartSettings) {

        // init default settings
        var defaultSettings = {
            bodySelector: "body",
            nonScrollClass: "non-scroll",
            toggleCartSelector: "[data-cart-toggle]",
            closeCartSelector: "[data-cart-close]",
            cartSelector: "[data-side-cart]",
            cartItemSelector: '[data-cart-item]',
            cartItemsSelector: '[data-cart-items]',
            cartItemRemoveSelector: '[data-cart-item-remove]',
            cartItemQuantity: ['data-cart-quantity'],
            cartTotalPriceSelector: '[data-cart-total-price]',
            cartFooterSelector: '[data-cart-footer]',
            updateCartSelector: '[data-add-to-cart]',
            backgroundSelector: "[data-cart-background-overlay]",
            openCartClass: 'open',
            activeBackgroundClass: "active",
            headerSelector: '.header',
            headerNotLight: 'not-light',
            cartCount: '#CartCount',
            cartFooterContent: "[data-cart-footer]",
            // Side cart
            sideCartEmpty: '[data-side-cart-empty]',
            // Progress bar
            progressPriceSelector : '[data-progress-price]',
            progressGoalAttr : 'data-progress-goal',
            progressContainerSelector : '[data-progress-container]',
            progressBarContainerSelector : '[data-progress-bar-container]',
            progressBarSelector : '[data-progress-bar]',
            progressReachClass : 'cart-progress__container--reached',
            deliveryContainer : '[data-side-cart-delivery]',
            deliveryFreeClass : 'cart-footer_delivery--free',
            // Stock message
            stockMessageQuantity : '[data-stock-message-parure]',
            // Cross sell
            crossSellSlider : '[data-cross-sell-slider]',
            crossSellButton : '[data-add-to-cart-cross-sell]',
            crossSellContainer : '[data-container-cross-sell]',
            singleOptionSelector: 'data-single-option-selector',
            singleOptionTrigger: '[data-single-option-trigger]',
            originalSelectorId: 'data-product-select-cross-sell',
            productJson: '[data-product-json-cross-sell]',
            addToCartText: '[data-add-to-cart-text]'

        };
        // merge settings
        settings = $.extend({}, defaultSettings, cartSettings);

        // init cart
        $(document).on('cart.ready', function (event, cart) {
            constructCart(cart);
        });

        // call classic function on click on trigger elemets
        $(settings.toggleCartSelector).on('click', function () {
            if (activateSideCart) {
                toggleCart();
            } else {
                location.href = '/cart';
            }
            return false;
        });

        $('body').on('click', settings.closeCartSelector, function () {
            closeCart();
            return false;
        });

        $(document).on('cart.requestComplete', function (event, cart) {
            event.preventDefault();
            constructCart(cart);
        });

        $("body").on('change', '[data-cart-change-href]', function(){
            var changeUrl = $(this).val();

            jQuery.ajax({
                dataType: 'json',
                url: changeUrl,
                success: function(response) {
                    constructCart(response);
                }
            });
        });

        $("body").on('click', '[data-cart-remove-href]', function(){
            var removeUrl = $(this).data("cart-remove-href");

            jQuery.ajax({
                dataType: 'json',
                url: removeUrl,
                success: function(response) {
                    constructCart(response);
                }
            });
        });

    }

    function getPrice(price, cart) {
        var price = Number(price / 100).toFixed(2);
        if (cart.currency == "EUR")
            return price + "€";
        else
            return price + "$";
    }

    function constructCart(cart) {

        // create elements
        var items = [];
        var c = null;
        var nbrCartItem = 0;

        for (var i = 0, l = cart.items.length; i < l; i++) {
            c = cart.items[i];

            var product_title = c.product_title;
            if (c.properties['_title']) product_title = c.properties['_title'];

            var variant_title = c.variant_title;
            if (c.properties['_subtitle']) variant_title = c.properties['_subtitle'];

            var context = {
                item_image: c.image,
                item_variant_title: variant_title,
                item_variant_id: c.variant_id,
                item_product_title: product_title,
                item_price: c.price,
                item_quantity: c.quantity,
                item_quantity_plus: c.quantity + 1,
                item_quantity_minus: c.quantity - 1,
                item_line_price: getPrice(c.line_price, cart).replace(".00", ""),
                item_url: c.url,
                item_product_type: c.product_type,
                item_properties: c.properties,
                item_sku: c.sku,
                item_handle: c.handle,
                item_key: c.key
            };

            nbrCartItem += c.quantity;
            items.push(context);
        }

        if (nbrCartItem > 0) {
            $(settings.sideCartEmpty).addClass("hide");
            $(settings.cartFooterContent).removeClass("hide");
            $(settings.cartSelector + " form").removeClass("hide");
        } else if (nbrCartItem == 0) {
            $(settings.sideCartEmpty).removeClass("hide");
            $(settings.cartSelector + " form").addClass("hide");
            $(settings.cartFooterContent).addClass("hide");
        }

        if ($("#cart-items").length != 0 && $("#cart-items__result").length != 0) {
            updateCartItems(items, cart);
        }

        $(settings.cartTotalPriceSelector).html(getPrice(cart.total_price, cart));
        $(settings.cartCount + " span").html(nbrCartItem);


        // Change progress bar
        var price = cart.total_price;
        var progressGoal = $(settings.progressPriceSelector).attr(settings.progressGoalAttr);
        var relation = (price / progressGoal) * 100;
        var difference = ((progressGoal - price) / 100).toString().replace('.',',');
        $(settings.progressPriceSelector).html(difference);
        if (relation >= 100) {
            $(settings.progressContainerSelector).addClass(settings.progressReachClass);
            $(settings.deliveryContainer).addClass(settings.deliveryFreeClass);
            $(settings.progressBarSelector).width('100%');
        } else {
            $(settings.progressContainerSelector).removeClass(settings.progressReachClass);
            $(settings.deliveryContainer).removeClass(settings.deliveryFreeClass);
            if(relation <= 0) relation = 0;
            $(settings.progressBarSelector).width(relation + '%');
        }

        // Cross sell
        var $container = $(settings.crossSellContainer);
        var productSingleObject = JSON.parse($(settings.productJson, this.$container).html());

        Object.entries(productSingleObject).forEach(([key, prop], i) => {

            var product = prop;

            var options = {
                $container: $container,
                enableHistoryState: $container.data('enable-history-state') || false,
                singleOptionSelector: '[' + settings.singleOptionSelector + '-' + i + ']',
                originalSelectorId: '[' + settings.originalSelectorId + '-' + i + ']',
                product: product
            };

            this.variants = new slate.Variants(options);

        });

        $container.on('variantChange', updateAddToCartState.bind(this));

        $(settings.singleOptionTrigger).click(function(){
            $(this).prev().click();
            $(this).parents('.selector-wrapper').find(settings.singleOptionTrigger).each(function(){
                $(this).removeClass('selected');
            });
            $(this).addClass('selected');
        });

        var $crossSellSlider = $(settings.crossSellSlider).flickity({
            wrapAround : true,
            imagesLoaded: true,
            "pageDots": false,
            "groupCells": 1,
            "contain" : true,
            adaptiveHeight: true,
            "arrowShape" : {x0: 50, x1: 50, y1: 0, x2: 50, y2: 0, x3: 50}
        });

        $crossSellSlider.on('ready.flickity', function(){
            $crossSellSlider.resize();
            $(selectors.productSlider).css('opacity', 1);
            $(selectors.productThumbnail).css('opacity', 1);
        });

        // UPDATE GIFT QTY
        $("[data-cart-gift-quantity]").on("change", function(){
            var qty = parseInt($(this).find(":selected").text());
            var price = $("[data-cart-gift-price]")[0];
            price = parseFloat($(price).attr("data-cart-gift-price"));
            price = parseFloat(price).toFixed(2);

            price = parseFloat(price * qty);

            $("[data-cart-gift-price]").html(price + "€");
        })

        // console.log("loading end");
        $("[data-cart-items-content]").removeClass("hide");
        $("[data-cart-loading]").addClass("hide");

    }

    function updateAddToCartState(evt) {
        var variant = evt.variant;
        var currentContainer = ".carousel-cell.is-selected";

        if (!variant) {
            $(currentContainer + " " + settings.crossSellButton).prop('disabled', true);
            $(currentContainer + " " + settings.crossSellButton).addClass('button--disabled');
            $(currentContainer + " " + settings.crossSellButton).html(theme.strings.unavailable);
            return;
        } else {
            var variantImage = variant.featured_image.src;
            var price = parseFloat(variant.price / 100).toFixed(2);
            var currency = $(currentContainer + ' [data-product-price]').html().slice(-1);
            if (currency != "€" && currency != "$") currency = "€";
            $(currentContainer + ' [data-product-price]').html(price + currency);
            $(currentContainer + ' [data-image-cross-sell]').attr("src", variantImage);
        }

        if (variant.available) {
            $(currentContainer + " " + settings.crossSellButton).prop('disabled', false);
            $(currentContainer + " " + settings.crossSellButton).removeClass('button--disabled');
            $(currentContainer + " " + settings.addToCartText).html(theme.strings.addToCart);
        } else {
            $(currentContainer + " " + settings.crossSellButton).prop('disabled', true);
            $(currentContainer + " " + settings.crossSellButton).addClass('button--disabled');
            $(currentContainer + " " + settings.addToCartText).html(theme.strings.soldOut);
        }

    }

    function getItemProps(props, sku, parureSku) {

        if (props.length > 0) {

            console.log("props: ", props);
            var name = props[0][0];
            var option = props[0][1];
            var handle = props[1][1];
            var parureSku = props[2][1];
            if (typeof option == "string") {
                var imageOption = option.toUpperCase();
            } else {
                var imageOption = "Une erreur est survenue sur ce produit";
            }

            console.log(imageOption);

            if (handle.includes('-')) {
                getBundleInfos(handle, sku, imageOption, parureSku);
            }

            var bundleInfos = [name, option, parureSku];
            return bundleInfos;
        }

    }


    function getBundleInfos(handle, sku, imageOption, parureSku){

        const inventoryQuery = `
        {
            productByHandle(handle: "` + handle + `") {
				id
				title
				variants(first: 100) {
					edges {
						node {
                            available
                            availableForSale
                            quantityAvailable
                            id
                            title
                            sku
                            image {
                                src
                                altText
                            }
                            product {
                                productType
                                tags
                                title
                            }
                        }
					}
				}
            }
        }
        `;

		const params = {
			query : inventoryQuery
        };

		const optionsQuery = {
			method: "post",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json",
				"X-Shopify-Storefront-Access-Token": "2bd4994327f59bcd1ea4aeadf72c7034"
			},
			body: JSON.stringify(params)
		};

		return fetch(`/api/2020-10/graphql`, optionsQuery)
        .then(res => res.json())
        .then(response => {

            var matiere, title, alt, src;
            var variantsArray = response.data.productByHandle.variants.edges;

            variantsArray.forEach(variant => {
                var variantTitle = variant.node.title.toUpperCase();

                if ((variantTitle.includes(imageOption.toUpperCase()) || variantTitle == imageOption.toUpperCase())) {

                    if (!parureSku) {
                        if (variant.node.quantityAvailable < 16) {
                            var newText = $(settings.stockMessageQuantity).text().replace('##stock##', '<span>' + variant.node.quantityAvailable + '</span>');
                            $('#stock-message-' + sku).html(newText).addClass("cart-stock-message--quantity").attr('data-quantity', variant.node.quantityAvailable);
                            if (variant.node.quantityAvailable < 11) {
                                $('#product-quantity-' + sku + ' > option').each(function() {
                                    if (variant.node.quantityAvailable < this.value) {
                                        $(this).attr("disabled", true);
                                        $(this).hide();
                                    }
                                });
                            }
                        }
                    } else {

                        src = variant.node.image.src;
                        alt = variant.node.image.altText;

                        if (variant.node.product.tags.find(a =>a.includes("__matiere"))) {
                            matiere = variant.node.product.tags.find(a =>a.includes("__matiere")).split(':')[1];
                            title = variant.node.product.title.replace(matiere, "");
                            $('#bundle-title-' + parureSku).each(function() {$(this).html(title).fadeTo("fast", 1)});
                        }

                        $('.bundle-image-' + parureSku).each(function() {$(this).attr("src", src);})
                        $('.bundle-image-' + parureSku).each(function() {$(this).attr("alt", alt);})

                        if (variant.node.product.productType.includes("couette")) {
                            if (variant.node.quantityAvailable < 16) {
                                var newText = $(settings.stockMessageQuantity).text().replace('##stock##', '<span>' + variant.node.quantityAvailable + '</span>');
                                $('#stock-message-' + sku).html(newText).addClass("cart-stock-message--quantity").attr('data-quantity', variant.node.quantityAvailable);
                                if (variant.node.quantityAvailable < 11) {
                                    $('#product-quantity-' + sku + ' > option').each(function() {
                                        if (variant.node.quantityAvailable < this.value) {
                                            $(this).attr("disabled", true);
                                            $(this).hide();
                                        }
                                    });
                                }
                            }
                        }
                    }

                }

            });

            loopQuantityMessage();

        });
    }

    function loopQuantityMessage() {
        var minValue;
        var minItem;
        $('#stock-message-timer').addClass("cart-stock-message--hide");
        $(".cart-stock-message--quantity").each(function() {
            $(this).addClass("cart-stock-message--hide");
            var val = parseInt($(this).attr("data-quantity"), 10);
            if (val && (!minItem || val < minValue)) {
                minItem = this;
                minValue = val;
            }
        });

        if (minItem) {
            $(minItem).removeClass("cart-stock-message--hide");
        } else {
            $('#stock-message-timer').removeClass("cart-stock-message--hide");
        }
    }

    function updateCartItems(items, cart) {
        var itemArr = [];
        var giftItem = [];

        items.forEach(item => {
            if (item.item_product_type == "Parure") {
                jQuery.ajax({
                    dataType: 'json',
                    url: item.item_url,
                    success: function(parure) {
                        item["parure"] = parure.product;
                    }
                });
            }
            itemArr.push(item);
        });

        itemArr.forEach(function(item, index, object) {

            var isBroderie;
            var isBundleChild;
            var broderieInfos = {};
            var broderieValue, broderie_handle, broderie_variant_id, broderieText1, broderieText2, broderieColor1, broderieColor2, broderieFont, broderiePrice;


            Object.entries(item.item_properties).forEach(([key, prop], i) => {

                // if is gift
                if (typeof prop === 'string' && prop.includes('gift')) {
                    giftItem.push(item);
                }

                // if has broderie
                if (key && key == '_Token') {
                    broderieValue = prop;
                    isBroderie = true;
                } else if (key && key == '_Ref') {
                    var props = prop.split('#');
                    broderie_handle = props[0];
                    broderie_variant_id = props[1];
                }
                if (key && key == '_TEXTE1') {
                    broderieText1 = prop;
                } else if (key && key == '_TEXTE2') {
                    broderieText2 = prop;
                } else if (key && key == '_COULEUR1') {
                    broderieColor1 = prop;
                } else if (key && key == '_COULEUR2') {
                    broderieColor2 = prop;
                } else if (key && key == '_FONT') {
                    broderieFont = prop;
                } else if (key && key == '_Price') {
                    broderiePrice = prop;
                }

            });

            // if has parure
            if (item.item_product_type.includes("Parure") && Object.entries(item.item_properties).length >= 9) {
                var bundle1 = Object.entries(item.item_properties).slice(0,3);
                var bundle2 = Object.entries(item.item_properties).slice(3,6);
                var bundle3 = Object.entries(item.item_properties).slice(6,9);

                if (item.item_product_title.includes("Enfant")) {
                    var bundleInfosNew = [getItemProps(bundle1, item.item_sku), getItemProps(bundle2, item.item_sku)];
                } else {
                    var bundleInfosNew = [getItemProps(bundle1, item.item_sku), getItemProps(bundle2, item.item_sku), getItemProps(bundle3, item.item_sku)];
                }

                item["bundle"] = bundleInfosNew;
            } else if (Object.entries(item.item_properties).length == 6) {
                var bundle1 = Object.entries(item.item_properties).slice(0,3);
                var bundle2 = Object.entries(item.item_properties).slice(3,6);

                var bundleInfosNew = [getItemProps(bundle1, item.item_sku), getItemProps(bundle2, item.item_sku)];
                item["bundle"] = bundleInfosNew;
            } else if (item.item_product_type != "broderie") {
                getBundleInfos(item.item_handle, item.item_sku, item.item_variant_title);
            }

            if (item.item_product_title.includes("Enfant")) {
                isBundleChild = true;
                item["isBundleChild"] = isBundleChild;
            }

            if (isBroderie) {

                var newPrice = getPrice((parseInt(broderiePrice) + parseInt(item.item_price)), cart).replace(".00", "");

                broderieInfos["broderieValue"] = broderieValue;
                broderieInfos["broderieText1"] = broderieText1;
                broderieInfos["broderieText2"] = broderieText2;
                broderieInfos["broderieColor1"] = broderieColor1;
                broderieInfos["broderieColor2"] = broderieColor2;
                broderieInfos["broderieFont"] = broderieFont;
                broderieInfos["newPrice"] = newPrice;

                item["isBroderie"] = isBroderie;
                item["broderieInfos"] = broderieInfos;
            }

            console.log("i : ", item);
        });

        if (giftItem.length > 0) {
            $("#cart-gift__result").removeClass('hide');
            $("#cart-gift-container").addClass('hide');
        } else {
            $('[data-open-cart-gift]').prop( "checked", false );
            $("#cart-gift__result").addClass('hide');
            $("#cart-gift-container").removeClass('hide');
        }

        // Cart item template
        var tempFn = doT.template(document.getElementById('cart-items').innerHTML);
        var resultText = tempFn({
            "items": itemArr
        });
        document.getElementById('cart-items__result').innerHTML = resultText;

        // Gift item template
        var tempFn = doT.template(document.getElementById('cart-gift').innerHTML);
        var resultText = tempFn({
            "items": giftItem
        });
        document.getElementById('cart-gift__result').innerHTML = resultText;

        if ($('[data-cross-sell-slider]').length > 0 && $('[data-cross-sell-slider]').data('flickity')) {
            $('[data-cross-sell-slider]').data('flickity').resize();
        }
    }

    function openCart() {

        /*
        jQuery.getJSON('/cart.js', function(cart) {
            constructCart(cart);
        } );
        */

        $(window).trigger('closeSearch')

        if ($('body').hasClass('template-cart')) return;

        $(settings.bodySelector).addClass(settings.nonScrollClass);
        $(settings.cartSelector).addClass(settings.openCartClass);
        $(settings.backgroundSelector).addClass(settings.activeBackgroundClass);
        $(settings.headerSelector).addClass(settings.headerNotLight);
    }

    function closeCart() {
        $('[data-cart-gift]').removeClass('side-cart-gift-open');
        $('[data-open-cart-gift]').prop( "checked", false );
        $(settings.bodySelector).removeClass(settings.nonScrollClass);
        $(settings.cartSelector).removeClass(settings.openCartClass);
        $(settings.backgroundSelector).removeClass(settings.activeBackgroundClass);
        $(settings.headerSelector).removeClass(settings.headerNotLight);
        if ($('body').hasClass('template-cart'))
            window.location.href = "/";

    }

    function toggleCart() {
        if ($(settings.cartSelector).hasClass(settings.openCartClass))
            closeCart();
        else
            openCart();
    }

    return cart;
}

var cart = new theme.cart();


$(function () {
    $('[data-open-cart-gift]').change(function() {
        if ($(this).is(":checked")) {
            $('[data-cart-gift]').addClass('side-cart-gift-open');
        }
    });

    $('[data-close-cart-gift]').on('click', function(){
        $('[data-cart-gift]').removeClass('side-cart-gift-open');
        $('[data-open-cart-gift]').prop( "checked", false );
    });

    $('[data-add-to-cart-cross-sell]').click(function(e){
        e.preventDefault();
        var container = $("[data-cross-sell-slider]").find(".is-selected");

        var price = container.find("[data-product-price]").html();
        var title = container.find(".cross-sell__product-title a").html();
        title = title.trim();

        var $form = $(this).closest('form');
        var data = getFormData($form);

        var variant = " - ";
        if (data["Color"] != undefined && data["Taille"] != undefined) {
            variant = data["Color"] + " / " + data["Taille"];
        } else if (data["Color"] != undefined) {
            variant = data["Color"];
        } else if (data["Taille"] != undefined) {
            variant = data["Taille"];
        }

        if (typeof ga != "undefined") {
            // ga('create', 'UA-110071462-1', 'auto');
            ga("send", {
                hitType: 'event',
                eventCategory: 'upsell',
                eventAction: 'add',
                eventLabel: title + variant,
                eventPrice: price
            });
        }
        addProduct(data, true);
    })

    $('[data-checkout-button-side-cart]').click(function(e){
        if($('[data-accept]').is(':checked') == false){
            e.preventDefault();
        } else {
            window.location.href = "/checkout";
            // $('[data-side-cart-form]').submit();
        }
    });

});


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function () {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);
    sections.register('bundle', theme.Bundle);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function (evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Target tables to make them scrollable
    var tableSelectors = '.rte table';

    slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: 'rte__table-wrapper',
    });

    // Target iframes to make them responsive
    var iframeSelectors =
        '.rte iframe[src*="youtube.com/embed"],' +
        '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: 'rte__video-wrapper'
    });

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }


});

/*================ Custom ================*/

theme.banner = new function () {

    var settings = {};

    function banner(bannerSettings) {

        var defaultSettings = {
            headerSelector: '#shopify-section-header',
            bannerSelector: '[data-banner]',
            selectorData: 'banner',
            prevNextButtons: false,
            pageDots: false,
            autoPlay: 3000
        };

        $(document).ready(function () {
            resizeWindow();
        });

        window.addEventListener('resize', function () {
            resizeWindow();
        });

        $(window).scroll(function () {
            document.documentElement.style.setProperty('--header-height-real', $('.header').height() + 'px');
        });

        settings = $.extend({}, defaultSettings, bannerSettings);

        $(settings.bannerSelector).each(function () {

            var el = $(this);

            $(this).imagesLoaded(function () {
                var elementSettings = $(el).data(settings.selectorData);
                var finalSettings = $.extend({}, settings, elementSettings);

                var $flick = $(el).flickity({
                    autoPlay: finalSettings.autoPlay,
                    lazyLoad: 'true',
                    pageDots: finalSettings.pageDots,
                    prevNextButtons: finalSettings.prevNextButtons
                });
                if (finalSettings.changeMobileButton) {
                    $flick.on('change.flickity', function (event, index) {
                        var cellElement = $flick.flickity('getCellElements')[index];
                        var textButton = cellElement.dataset.textButton;
                        var urlButton = cellElement.dataset.urlButton;

                        $('[data-banner-mobile-button]').html(textButton);
                        $('[data-banner-mobile-button]').attr('href', urlButton);
                        // cellElement.find('[data-banner-mobile-button]').html(cellElement.attr('data-text-button'));
                    });
                }
                $flick.on('dragStart.flickity', function (event, pointer) {
                    document.ontouchmove = function (e) {
                        e.preventDefault();
                    }
                });
                $flick.on('dragEnd.flickity', function (event, pointer) {
                    document.ontouchmove = function (e) {
                        return true;
                    }
                });
            });

        });
    }

    $('[data-promo-close]').on('click', function () {
        $('[data-promo-banner]').addClass('hide');
        Cookies.set('topbarVisibility', false);
        resizeWindow();
    });

    function resizeWindow() {
        var windowWidth = window.innerWidth,
            headerSection = $(settings.headerSelector);

        document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
        if (headerSection) {
            document.documentElement.style.setProperty('--header-height', headerSection.height() + 'px');
            document.documentElement.style.setProperty('--header-height-real', $('.header').height() + $('.header__submobile').height() + 'px');
            // console.log("header height real ", $(settings.headerSelector).height());
        }
    };

    return banner;
}

var banner = new theme.banner();


/** header **/

theme.header = new function () {
    var settings = {};

    function header(headerSettings) {

        // init default settings
        var defaultSettings = {
            bodySelector: "body",
            nonScrollClass: "non-scroll",
            headerId: "shopify-section-header",
            headerSelector: '.header',
            headerTransparent: 'header--transparent',
            toggleSideNav: '[data-header-toggle]',
            sideNavSelector: '[data-header-side-nav]',
            openSideNavClass: 'active',
            lightClass: 'light',
            headerNotLight: 'not-light'
        };

        // merge settings
        settings = $.extend({}, defaultSettings, headerSettings);

        //if ($(settings.headerSelector).hasClass('header--transparent')) {
        checkHeaderStatus();
        $(window).on("scroll", function () {
            checkHeaderStatus();
        });
        //}

        $(settings.toggleSideNav).on('click', function () {
            toggleSideNav();
        });

        resizeWindow();
        createUnderline()
        window.addEventListener('resize', function () {
            resizeWindow();
            createUnderline()
        });
    }

    function createUnderline() {
        $('.header__menu-item').each(function (i) {
            var width = $(this).width();
            $(this).attr('id', 'header__menu-item-' + i);
            $('body').append('<style>#header__menu-item-' + i + ':after{width: ' + width + 'px;left:' + $(this).offset().left + 'px;}</style>');
        })
    }

    function openSideNav() {
        $(settings.sideNavSelector).addClass(settings.openSideNavClass);
        $(settings.headerSelector).addClass(settings.headerNotLight);
        $(settings.bodySelector).addClass(settings.nonScrollClass);

    }

    function closeSideNav() {
        $(settings.sideNavSelector).removeClass(settings.openSideNavClass);
        $(settings.headerSelector).removeClass(settings.headerNotLight);
        $(settings.bodySelector).removeClass(settings.nonScrollClass);
    }

    function toggleSideNav() {
        if ($(settings.sideNavSelector).hasClass(settings.openSideNavClass))
            closeSideNav();
        else
            openSideNav();
    }

    function checkHeaderStatus() {
        var transparencyHeight = $(window).height() - $('.header').height() - $('.header__submobile').height();
        if ($('[data-transparency-height]').length) transparencyHeight = $('[data-transparency-height]').height() - $('.header').height() - $('.header__submobile').height();

        if ($(window).scrollTop() > transparencyHeight) {
            if ($(settings.headerSelector).hasClass('light')) {
                $(settings.headerSelector).removeClass("light");
                $(settings.headerSelector).addClass("little");
                $('#' + settings.headerId).addClass('sticky-header');
                if ($(settings.headerSelector).hasClass('header--transparent')) {
                    $('#' + settings.headerId).removeClass('absolute-header');
                } else {
                    var marginTop = $(settings.headerSelector).height();
                    if ($('.header__submobile--link').length > 1) marginTop += 25;
                    $('body').css('margin-top', marginTop + 'px');
                }
                $(settings.headerSelector).trigger('headerChange');
            }
        } else {
            if ($(settings.headerSelector).hasClass('little')) {
                $(settings.headerSelector).addClass("light");
                $(settings.headerSelector).removeClass("little");
                $('#' + settings.headerId).removeClass('sticky-header');
                if ($(settings.headerSelector).hasClass('header--transparent')) {
                    $('#' + settings.headerId).addClass('absolute-header');
                } else {
                    $('body').css('margin-top', 0);
                }
                $(settings.headerSelector).trigger('headerChange');
            }
        }
    }

    function resizeWindow() {
        var windowWidth = window.innerWidth,
            headerSection = document.getElementById(settings.headerId);
        document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
        if (headerSection) {
            document.documentElement.style.setProperty('--header-height', headerSection.clientHeight + 'px');
            document.documentElement.style.setProperty('--header-height-real', $('.header').height() + $('.header__submobile').height() + 'px');
        }
    };

    return header;
}

var header = new theme.header();

/** side guide **/

theme.guide = new function () {

    var settings = {};

    function guide(guideSettings) {

        // init default settings
        var defaultSettings = {
            openGuideSelector: "[data-guide-open]",
            toggleGuideSelector: "[data-guide-toggle]",
            closeGuideSelector: "[data-guide-close]",
            guideSelector: "[data-side-guide]",
            guideItemSelector: '[data-guide-item]',
            guideItemsSelector: '[data-guide-items]',
            guideItemRemoveSelector: '[data-guide-item-remove]',
            guideTotalPriceSelector: '[data-guide-total-price]',
            guideFooterSelector: '[data-guide-footer]',
            updateGuideSelector: '[data-add-to-guide]',
            backgroundSelector: "[data-guide-background-overlay]",
            openGuideClass: 'open',
            activeBackgroundClass: "active",
            emptyGuideText: '<div class="guide__empty-state heading z-h2">Votre panier est vide</div>',
            headerSelector: '.header',
            headerNotLight: 'not-light'
        };
        // merge settings
        settings = $.extend({}, defaultSettings, guideSettings);

        // init guide
        $(document).on('guide.ready', function (event, guide) {
            //console.log('guide ready guide');
            constructGuide(guide, false);
        });

        // call classic function on click on trigger elemets
        $(settings.toggleGuideSelector).on('click', function () {
            toggleGuide();
            return false;
        });

        $('body').on('click', settings.closeGuideSelector, function () {
            closeGuide();
            return false;
        });

        $(settings.openGuideSelector).on('click', function () {
            openGuide();
            return false;
        });

        $(document).on('guide.requestComplete', function (event, guide) {
            constructGuide(guide, true);
        });
    }

    function getPrice(price, guide) {
        var price = Number(price / 100).toFixed(2);
        if (guide.currency == "EUR")
            return price + "€";
        else
            return price + "$";
    }

    function constructGuide(guide, open) {
        // create elemets
        var contexts = [];
        var context = {};
        var c = null;
        var final_html = "";
        var source = "";
        var template = null;

        for (var i = 0, l = guide.items.length; i < l; i++) {
            c = guide.items[i];
            var context = {
                item_image: c.image,
                item_variant_title: c.variant_title,
                item_variant_id: c.variant_id,
                item_product_type: c.product_type,
                item_product_title: c.product_title,
                item_price: getPrice(c.price, guide),
                item_quantity: c.quantity,
                item_quantity_plus: c.quantity + 1,
                item_quantity_minus: c.quantity - 1,
                item_line_price: getPrice(c.line_price, guide),
                item_url: c.url
            };
            source = $(settings.guideItemSelector).html();
            template = Handlebars.compile(source);
            html = template(context);
            final_html += html;
        }

        $(settings.guideTotalPriceSelector).html(getPrice(guide.total_price, guide));

        if (guide.items.length > 0) {
            $(settings.guideItemsSelector).html(final_html);
        } else {
            $(settings.guideItemsSelector).html(settings.emptyGuideText);
        }

        if (open)
            openGuide();
    }

    function openGuide() {

        if ($('body').hasClass('template-guide')) return;

        $(settings.guideSelector).addClass(settings.openGuideClass);
        $(settings.backgroundSelector).addClass(settings.activeBackgroundClass);
        $(settings.headerSelector).addClass(settings.headerNotLight);
    }

    function closeGuide() {
        $(settings.guideSelector).removeClass(settings.openGuideClass);
        $(settings.backgroundSelector).removeClass(settings.activeBackgroundClass);
        $(settings.headerSelector).removeClass(settings.headerNotLight);
        if ($('body').hasClass('template-guide'))
            window.location.href = "/";

    }

    function toggleGuide() {
        if ($(settings.guideSelector).hasClass(settings.openGuideClass))
            closeGuide();
        else
            openGuide();
    }

    return guide;
}

var guide = new theme.guide();


// Flickity custom wrapper
var addNextReviews = function () {
    var nextName = null;
    var prevName = null;
    $('.reviews__carousel .flickity-prev-next-button.previous').append('<span class="text previous-name">Previous name</span>')
    $('.reviews__carousel .flickity-prev-next-button.next').prepend('<span class="text next-name">Next name</span>')

    $('.reviews__carousel .flickity-prev-next-button.previous').hover(function () {
        prevName = null;
        prevName = $(this).parent().find('.carousel-cell.is-selected').prev().attr('data-name');
        if (!prevName) prevName = $(this).parent().find('.carousel-cell').last().attr('data-name');
        if (prevName) $('.previous-name').html(prevName);
    });
    $('.reviews__carousel .flickity-prev-next-button.previous').click(function () {
        prevName = null;
        prevName = $(this).parent().find('.carousel-cell.is-selected').prev().attr('data-name');
        if (!prevName) prevName = $(this).parent().find('.carousel-cell').last().attr('data-name');
        if (prevName) $('.previous-name').html(prevName);
    });
    $('.reviews__carousel .flickity-prev-next-button.next').hover(function () {
        nextName = null;
        nextName = $(this).parent().find('.carousel-cell.is-selected').next().attr('data-name');
        if (!nextName) nextName = $(this).parent().find('.carousel-cell').first().attr('data-name');
        if (nextName) $('.next-name').html(nextName);
    });
    $('.reviews__carousel .flickity-prev-next-button.next').click(function () {
        nextName = null;
        nextName = $(this).parent().find('.carousel-cell.is-selected').next().attr('data-name');
        if (!nextName) nextName = $(this).parent().find('.carousel-cell').first().attr('data-name');
        if (nextName) $('.next-name').html(nextName);
    });
}


$(function () {
    $('[data-custom-flickity]').each(function () {
        var self = this;
        var $self = $(this);
        try {
            var parameters = JSON.parse($(this).attr('data-custom-flickity'));
        } catch (e) {
            console.log('Error with JSON Parse', e);
        }
        var $carousel = $(this);

        // Fix for lazyload + flickity -- Mac retina
        $(this).find('img.lazyload').each(function () {
            $(this).on('load',
                function () {
                    //console.log('Resize carousel on load');
                    $carousel.resize();
                    $carousel.find('.flickity-viewport').height($carousel.find('.carousel-cell').first().height() + 'px');
                })
        });
        $carousel.on('dragStart.flickity', function (event, pointer) {
            document.ontouchmove = function (e) {
                e.preventDefault();
            }
        });
        $carousel.on('dragEnd.flickity', function (event, pointer) {
            document.ontouchmove = function (e) {
                return true;
            }
        });
        // Disable button at slide X
        if (parameters.stopAt) {
            $carousel.on('change.flickity', function (event, index) {
                console.log('Slide changed to ', index);
                if (index >= parameters.stopAt) {
                    $self.find('.flickity-prev-next-button.next').prop('disabled', true);
                } else {
                    $self.find('.flickity-prev-next-button.next').prop('disabled', false);
                }
            });
        }
        $carousel.on('ready.flickity', function () {
            $('img.lazyload').on('load', function () {
                //console.log('Resize carousel on load');
                $carousel.resize();
            })
            // Add a class on carousel after loading, and resize
            if (parameters.addClassOnLoad) {
                setTimeout(function () {
                    $carousel.addClass(parameters.addClassOnLoad);
                    $carousel.find('.flickity-viewport').height($carousel.find('.carousel-cell').first().height() + 'px');
                }, 3000);
            }
            if (parameters.loadingResize) {
                $carousel.find('.flickity-viewport').height($carousel.find('.carousel-cell').first().height() + 'px');
            }
            if (parameters.addNextReviews) {
                addNextReviews();
            }
            if (parameters.slidableText) {
                $carousel.on('change.flickity', function (event, index) {
                    $carousel.parents('section').find('.carousel__slidable-text--activated').removeClass('carousel__slidable-text--activated');
                    $carousel.parents('section').find('[data-text-index="' + index + '"]').addClass('carousel__slidable-text--activated');

                });
            }
        });

        $carousel.flickity(parameters);
    });
});

$('.sidenav__menu-link--toggle').click(function () {
    $(this).next().slideToggle(100);
    if ($(this).hasClass('open')) $(this).removeClass('open');
    else $(this).addClass('open');
})

// Accordion dropdown
$('.accordion .accordion--question').on('click', function () {
    $(this).next().slideToggle(400);
    $(this).find(".accordion--icon").toggleClass("rotate");
});

$('[data-card-toggle]').on('click', function () {
    $(this).find("svg").toggleClass("rotate");
});

$('[data-scroll-to]').click(function () {
    var className = $(this).attr('data-scroll-to');
    var heightSum = $('.header').height() + $('.header__submobile').height();
    if ($(window).width() > 800) heightSum += 50;
    else heightSum -= 40;

    console.log('Class name : ', className);
    $("html, body").animate({
        scrollTop: $(className).offset().top - heightSum
    }, 1500);
});



(function () {
    let touchingCarousel = false,
        touchStartCoords;

    document.body.addEventListener('touchstart', function (e) {
        if (e.target.closest('.flickity-slider')) {
            touchingCarousel = true;
        } else {
            touchingCarousel = false;
            return;
        }

        touchStartCoords = {
            x: e.touches[0].pageX,
            y: e.touches[0].pageY
        }
    });

    document.body.addEventListener('touchmove', function (e) {
        if (!(touchingCarousel && e.cancelable)) {
            return;
        }

        let moveVector = {
            x: e.touches[0].pageX - touchStartCoords.x,
            y: e.touches[0].pageY - touchStartCoords.y
        };

        if (Math.abs(moveVector.x) > 7)
            e.preventDefault()

    }, {
        passive: false
    });
})();
